// @ts-nocheck
// generated with @7nohe/openapi-react-query-codegen@2.0.0-beta.3

import { queryResponseData } from './query-response';
import { type Options } from '@hey-api/client-fetch';
import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  abortAction,
  abortMediaLibraryUpload,
  abortWorkflow,
  abortWorkflowViaApi,
  activateInvitationCode,
  addNodesToCanvasPage,
  attachVideoEditProjectAssets,
  authorizeComposioConnection,
  autoNameCanvas,
  batchBindSocialAccountsToCategory,
  batchCreateDriveFiles,
  batchCreateProviderItems,
  batchCreateResource,
  batchCreateSocialAccounts,
  batchDeleteMediaLibraryEntries,
  batchUnbindSocialAccountsFromCategory,
  batchUpdateDocument,
  batchUpdateProviderItems,
  bindSocialAccountToCategory,
  cancelOneSocialAccountLoginBatch,
  cancelProductionStudioBatch,
  cancelSocialBrowserSession,
  cancelSocialBrowserSessionBatch,
  cancelSocialBrowserSessionBatchItem,
  checkSettingsField,
  checkSocialAccountInteractiveLogin,
  checkToolOauthStatus,
  checkVerification,
  claimVoucherInvitation,
  closeSocialAccountLoginBrowser,
  completeMediaLibraryUpload,
  completeSocialAccountInteractiveLogin,
  completeSocialBrowserSession,
  completeVideoManualEdit,
  confirmAllProductionStudioScripts,
  confirmProductionStudioScript,
  confirmVideoEditNarrative,
  continueSocialAccountLoginBatch,
  convert,
  copyProductionStudioBatch,
  createCanvas,
  createCanvasMaterialDownloadTask,
  createCanvasTemplate,
  createCanvasVersion,
  createCheckoutSession,
  createCliApiKey,
  createCodeArtifact,
  createCreditPackCheckoutSession,
  createDocument,
  createDriveFile,
  createLabelClass,
  createLabelInstance,
  createManagedModel,
  createMcpServer,
  createMediaLibraryDownloadTask,
  createMediaLibraryEntry,
  createPayOrder,
  createPilotSession,
  createPortalSession,
  createProductionStudioBatch,
  createProject,
  createPromptSkill,
  createProvider,
  createProviderItem,
  createResource,
  createResourceWithFile,
  createSchedule,
  createShare,
  createSkillInstance,
  createSkillTrigger,
  createSocialAccount,
  createSocialAccountAutoBindingBatch,
  createSocialAccountCategory,
  createSocialBrowserSession,
  createSocialBrowserSessionBatch,
  createToolset,
  createVerification,
  createVideoEditProject,
  createVoucherInvitation,
  createWorkflowApp,
  createWorkflowSkill,
  deleteCanvas,
  deleteCopilotSession,
  deleteDocument,
  deleteDriveFile,
  deleteLabelClass,
  deleteLabelInstance,
  deleteManagedModel,
  deleteMcpServer,
  deletePageNode,
  deleteProductionStudioBatch,
  deleteProductionStudioScript,
  deleteProject,
  deleteProjectItems,
  deletePromptSkill,
  deleteProvider,
  deleteProviderItem,
  deleteResource,
  deleteSchedule,
  deleteShare,
  deleteSkillInstance,
  deleteSkillTrigger,
  deleteSocialAccount,
  deleteSocialAccountCategory,
  deleteToolset,
  deleteWorkflowApp,
  deleteWorkflowSkill,
  downloadExportJobResult,
  duplicateCanvas,
  duplicateShare,
  emailLogin,
  emailSignup,
  ensureProductionStudioWorkspace,
  executeTool,
  executeWorkflowApp,
  exportCanvas,
  exportDocument,
  exportSocialBrowserState,
  exportToolsetDefinitions,
  extendSocialBrowserSession,
  extractVariables,
  generateAppTemplate,
  generateMedia,
  generateWorkflowViaCopilot,
  getActionResult,
  getActiveSocialBrowserSessionBatch,
  getAuthConfig,
  getAvailableTools,
  getAvailableVouchers,
  getCanvasData,
  getCanvasDetail,
  getCanvasMaterialAccessUrl,
  getCanvasMaterialDownloadTask,
  getCanvasState,
  getCanvasTransactions,
  getCodeArtifactDetail,
  getCollabToken,
  getComposioConnectionStatus,
  getCopilotSessionDetail,
  getCreditBalance,
  getCreditRecharge,
  getCreditUsage,
  getCreditUsageByCanvasId,
  getCreditUsageByExecutionId,
  getCreditUsageByResultId,
  getDocumentDetail,
  getExportJobStatus,
  getFormDefinition,
  getMediaLibraryDownloadTask,
  getMediaLibraryEntry,
  getMediaLibraryEntryAccessUrl,
  getMediaLibraryUploadStatus,
  getModelOptions,
  getOpenapiConfig,
  getPageByCanvasId,
  getPageDetail,
  getPayOrder,
  getPilotSessionDetail,
  getProductionStudioBatch,
  getProductionStudioOutputAccessUrl,
  getProductionStudioOutputStrategyArtifact,
  getProductionStudioWorkspace,
  getProjectDetail,
  getPromptSkillDetail,
  getPromptSuggestions,
  getRecordSnapshot,
  getResourceDetail,
  getScheduleDetail,
  getScheduleRecordDetail,
  getScheduleRecords,
  getSettings,
  getSocialAccount,
  getSocialAccountCategory,
  getSocialAccountLoginBatchStatus,
  getSocialAccountOverview,
  getSocialAccountWorkflows,
  getSocialBrowserSession,
  getSocialBrowserSessionBatch,
  getSocialPublishExecutorStatus,
  getSubscriptionPlans,
  getSubscriptionUsage,
  getTemplateGenerationStatus,
  getToolCallResult,
  getVideoEditAssetAccessUrl,
  getVideoEditProject,
  getVideoEditProjectSnapshot,
  getVideoEditVersion,
  getWorkflowAppDetail,
  getWorkflowDetail,
  getWorkflowDetailViaApi,
  getWorkflowOutput,
  getWorkflowPlanDetail,
  getWorkflowSkill,
  getWorkflowStatusViaApi,
  getWorkflowVariables,
  hasBeenInvited,
  hasFilledForm,
  importCanvas,
  importCanvasMaterialsFromLibrary,
  importCanvasMaterialsToLibrary,
  importProductionStudioClientPack,
  importProductionStudioScripts,
  importSocialBrowserState,
  importSocialBrowserStateFile,
  initializeMediaLibraryUpload,
  initializeWorkflow,
  invokeSkill,
  invokeWorkflowSkill,
  issueSocialBrowserStateExportTicket,
  issueSocialBrowserViewerTicket,
  listAllScheduleRecords,
  listCanvases,
  listCanvasMaterials,
  listCanvasTemplateCategories,
  listCanvasTemplates,
  listCategoriesBySocialAccount,
  listCliApiKeys,
  listCodeArtifacts,
  listCopilotSessions,
  listDocuments,
  listDriveFiles,
  listInvitationCodes,
  listLabelClasses,
  listLabelInstances,
  listManagedModels,
  listMcpServers,
  listMediaLibraryEntries,
  listModels,
  listPages,
  listPilotSessions,
  listProductionStudioClientPacks,
  listProjects,
  listPromptSkills,
  listProviderItemOptions,
  listProviderItems,
  listProviders,
  listResources,
  listSchedules,
  listShares,
  listSkillInstances,
  listSkills,
  listSkillTriggers,
  listSocialAccountCategories,
  listSocialAccounts,
  listSocialAccountsByCategory,
  listSocialPlatforms,
  listTools,
  listToolsetInventory,
  listToolsets,
  listUserTools,
  listUserVouchers,
  listWorkflowApps,
  listWorkflowExecutions,
  listWorkflowSkills,
  logout,
  manualBindSocialAccounts,
  materializeCopilotSession,
  moveSocialAccountsCategory,
  multiLingualWebSearch,
  openSocialBrowserViewerConnection,
  pauseProductionStudioBatch,
  pinSkillInstance,
  recognizeSocialAccounts,
  recoverPilotSession,
  refreshToken,
  regenerateProductionStudioScripts,
  regenerateVideoEditNarrative,
  reindexResource,
  resendVerification,
  restartWorkflowNode,
  retryScheduleRecord,
  reviewProductionStudioOutput,
  revokeCliApiKey,
  revokeComposioConnection,
  runWorkflowViaApi,
  saveOneSocialAccountLoginBatch,
  saveProductionStudioScript,
  saveSocialAccountLoginCookies,
  saveSocialBrowserState,
  saveVideoEditProjectSnapshot,
  scrape,
  search,
  searchMediaLibraryEntries,
  searchWorkflowsViaApi,
  serveStatic,
  setCanvasState,
  setSocialBrowserSessionAutomation,
  sharePage,
  signMediaLibraryUploadParts,
  startExportJob,
  startProductionStudioBatch,
  startSocialAccountInteractiveLogin,
  startSocialAccountLoginBatch,
  startSocialAccountReloginBatch,
  stopPublishTask,
  stopSocialAccountLoginBatch,
  streamInvokeSkill,
  submitForm,
  syncCanvasState,
  testProviderConnection,
  togglePromptSkill,
  triggerScheduleManually,
  unbindSocialAccountFromCategory,
  unpinSkillInstance,
  updateCanvas,
  updateCanvasTemplate,
  updateCliApiKey,
  updateCodeArtifact,
  updateDocument,
  updateDriveFile,
  updateLabelClass,
  updateLabelInstance,
  updateManagedModel,
  updateManagedModelStatus,
  updateMcpServer,
  updateMediaLibraryEntry,
  updateOpenapiConfig,
  updatePage,
  updatePilotSession,
  updateProductionStudioBatch,
  updateProductionStudioClientPackAsset,
  updateProductionStudioClientPackStatus,
  updateProject,
  updateProjectItems,
  updatePromptSkill,
  updateProvider,
  updateProviderItem,
  updateResource,
  updateSchedule,
  updateSettings,
  updateSkillInstance,
  updateSkillTrigger,
  updateSocialAccountCategory,
  updateSocialAccountCredential,
  updateSocialAccountProfile,
  updateSocialAccountRemark,
  updateSocialAccountStatus,
  updateToolset,
  updateWorkflowVariables,
  upload,
  uploadOpenapiFiles,
  validateMcpServer,
  validateVoucher,
  verifyVoucherInvitation,
} from '../requests/services.gen';
import {
  AbortActionData,
  AbortActionError,
  AbortMediaLibraryUploadData,
  AbortMediaLibraryUploadError,
  AbortWorkflowData,
  AbortWorkflowError,
  AbortWorkflowViaApiData,
  AbortWorkflowViaApiError,
  ActivateInvitationCodeData,
  ActivateInvitationCodeError,
  AddNodesToCanvasPageData,
  AddNodesToCanvasPageError,
  AttachVideoEditProjectAssetsData,
  AttachVideoEditProjectAssetsError,
  AuthorizeComposioConnectionData,
  AuthorizeComposioConnectionError,
  AutoNameCanvasData,
  AutoNameCanvasError,
  BatchBindSocialAccountsToCategoryData,
  BatchBindSocialAccountsToCategoryError,
  BatchCreateDriveFilesData,
  BatchCreateDriveFilesError,
  BatchCreateProviderItemsData,
  BatchCreateProviderItemsError,
  BatchCreateResourceData,
  BatchCreateResourceError,
  BatchCreateSocialAccountsData,
  BatchCreateSocialAccountsError,
  BatchDeleteMediaLibraryEntriesData,
  BatchDeleteMediaLibraryEntriesError,
  BatchUnbindSocialAccountsFromCategoryData,
  BatchUnbindSocialAccountsFromCategoryError,
  BatchUpdateDocumentData,
  BatchUpdateDocumentError,
  BatchUpdateProviderItemsData,
  BatchUpdateProviderItemsError,
  BindSocialAccountToCategoryData,
  BindSocialAccountToCategoryError,
  CancelOneSocialAccountLoginBatchData,
  CancelOneSocialAccountLoginBatchError,
  CancelProductionStudioBatchData,
  CancelProductionStudioBatchError,
  CancelSocialBrowserSessionBatchData,
  CancelSocialBrowserSessionBatchError,
  CancelSocialBrowserSessionBatchItemData,
  CancelSocialBrowserSessionBatchItemError,
  CancelSocialBrowserSessionData,
  CancelSocialBrowserSessionError,
  CheckSettingsFieldData,
  CheckSettingsFieldError,
  CheckSocialAccountInteractiveLoginData,
  CheckSocialAccountInteractiveLoginError,
  CheckToolOauthStatusData,
  CheckToolOauthStatusError,
  CheckVerificationData,
  CheckVerificationError,
  ClaimVoucherInvitationData,
  ClaimVoucherInvitationError,
  CloseSocialAccountLoginBrowserData,
  CloseSocialAccountLoginBrowserError,
  CompleteMediaLibraryUploadData,
  CompleteMediaLibraryUploadError,
  CompleteSocialAccountInteractiveLoginData,
  CompleteSocialAccountInteractiveLoginError,
  CompleteSocialBrowserSessionData,
  CompleteSocialBrowserSessionError,
  CompleteVideoManualEditData,
  CompleteVideoManualEditError,
  ConfirmAllProductionStudioScriptsData,
  ConfirmAllProductionStudioScriptsError,
  ConfirmProductionStudioScriptData,
  ConfirmProductionStudioScriptError,
  ConfirmVideoEditNarrativeData,
  ConfirmVideoEditNarrativeError,
  ContinueSocialAccountLoginBatchData,
  ContinueSocialAccountLoginBatchError,
  ConvertData,
  ConvertError,
  CopyProductionStudioBatchData,
  CopyProductionStudioBatchError,
  CreateCanvasData,
  CreateCanvasError,
  CreateCanvasMaterialDownloadTaskData,
  CreateCanvasMaterialDownloadTaskError,
  CreateCanvasTemplateData,
  CreateCanvasTemplateError,
  CreateCanvasVersionData,
  CreateCanvasVersionError,
  CreateCheckoutSessionData,
  CreateCheckoutSessionError,
  CreateCliApiKeyData,
  CreateCliApiKeyError,
  CreateCodeArtifactData,
  CreateCodeArtifactError,
  CreateCreditPackCheckoutSessionData,
  CreateCreditPackCheckoutSessionError,
  CreateDocumentData,
  CreateDocumentError,
  CreateDriveFileData,
  CreateDriveFileError,
  CreateLabelClassData,
  CreateLabelClassError,
  CreateLabelInstanceData,
  CreateLabelInstanceError,
  CreateManagedModelData,
  CreateManagedModelError,
  CreateMcpServerData,
  CreateMcpServerError,
  CreateMediaLibraryDownloadTaskData,
  CreateMediaLibraryDownloadTaskError,
  CreateMediaLibraryEntryData,
  CreateMediaLibraryEntryError,
  CreatePayOrderData,
  CreatePayOrderError,
  CreatePilotSessionData,
  CreatePilotSessionError,
  CreatePortalSessionError,
  CreateProductionStudioBatchData,
  CreateProductionStudioBatchError,
  CreateProjectData,
  CreateProjectError,
  CreatePromptSkillData,
  CreatePromptSkillError,
  CreateProviderData,
  CreateProviderError,
  CreateProviderItemData,
  CreateProviderItemError,
  CreateResourceData,
  CreateResourceError,
  CreateResourceWithFileData,
  CreateResourceWithFileError,
  CreateScheduleData,
  CreateScheduleError,
  CreateShareData,
  CreateShareError,
  CreateSkillInstanceData,
  CreateSkillInstanceError,
  CreateSkillTriggerData,
  CreateSkillTriggerError,
  CreateSocialAccountAutoBindingBatchData,
  CreateSocialAccountAutoBindingBatchError,
  CreateSocialAccountCategoryData,
  CreateSocialAccountCategoryError,
  CreateSocialAccountData,
  CreateSocialAccountError,
  CreateSocialBrowserSessionBatchData,
  CreateSocialBrowserSessionBatchError,
  CreateSocialBrowserSessionData,
  CreateSocialBrowserSessionError,
  CreateToolsetData,
  CreateToolsetError,
  CreateVerificationData,
  CreateVerificationError,
  CreateVideoEditProjectData,
  CreateVideoEditProjectError,
  CreateVoucherInvitationData,
  CreateVoucherInvitationError,
  CreateWorkflowAppData,
  CreateWorkflowAppError,
  CreateWorkflowSkillData,
  CreateWorkflowSkillError,
  DeleteCanvasData,
  DeleteCanvasError,
  DeleteCopilotSessionData,
  DeleteCopilotSessionError,
  DeleteDocumentData,
  DeleteDocumentError,
  DeleteDriveFileData,
  DeleteDriveFileError,
  DeleteLabelClassData,
  DeleteLabelClassError,
  DeleteLabelInstanceData,
  DeleteLabelInstanceError,
  DeleteManagedModelData,
  DeleteManagedModelError,
  DeleteMcpServerData,
  DeleteMcpServerError,
  DeletePageNodeData,
  DeletePageNodeError,
  DeleteProductionStudioBatchData,
  DeleteProductionStudioBatchError,
  DeleteProductionStudioScriptData,
  DeleteProductionStudioScriptError,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectItemsData,
  DeleteProjectItemsError,
  DeletePromptSkillData,
  DeletePromptSkillError,
  DeleteProviderData,
  DeleteProviderError,
  DeleteProviderItemData,
  DeleteProviderItemError,
  DeleteResourceData,
  DeleteResourceError,
  DeleteScheduleData,
  DeleteScheduleError,
  DeleteShareData,
  DeleteShareError,
  DeleteSkillInstanceData,
  DeleteSkillInstanceError,
  DeleteSkillTriggerData,
  DeleteSkillTriggerError,
  DeleteSocialAccountCategoryData,
  DeleteSocialAccountCategoryError,
  DeleteSocialAccountData,
  DeleteSocialAccountError,
  DeleteToolsetData,
  DeleteToolsetError,
  DeleteWorkflowAppData,
  DeleteWorkflowAppError,
  DeleteWorkflowSkillData,
  DeleteWorkflowSkillError,
  DownloadExportJobResultData,
  DownloadExportJobResultError,
  DuplicateCanvasData,
  DuplicateCanvasError,
  DuplicateShareData,
  DuplicateShareError,
  EmailLoginData,
  EmailLoginError,
  EmailSignupData,
  EmailSignupError,
  EnsureProductionStudioWorkspaceData,
  EnsureProductionStudioWorkspaceError,
  ExecuteToolData,
  ExecuteToolError,
  ExecuteWorkflowAppData,
  ExecuteWorkflowAppError,
  ExportCanvasData,
  ExportCanvasError,
  ExportDocumentData,
  ExportDocumentError,
  ExportSocialBrowserStateData,
  ExportSocialBrowserStateError,
  ExportToolsetDefinitionsData,
  ExportToolsetDefinitionsError,
  ExtendSocialBrowserSessionData,
  ExtendSocialBrowserSessionError,
  ExtractVariablesData,
  ExtractVariablesError,
  GenerateAppTemplateData,
  GenerateAppTemplateError,
  GenerateMediaData,
  GenerateMediaError,
  GenerateWorkflowViaCopilotData,
  GenerateWorkflowViaCopilotError,
  GetActionResultData,
  GetActionResultError,
  GetActiveSocialBrowserSessionBatchError,
  GetAuthConfigError,
  GetAvailableToolsError,
  GetAvailableVouchersError,
  GetCanvasDataData,
  GetCanvasDataError,
  GetCanvasDetailData,
  GetCanvasDetailError,
  GetCanvasMaterialAccessUrlData,
  GetCanvasMaterialAccessUrlError,
  GetCanvasMaterialDownloadTaskData,
  GetCanvasMaterialDownloadTaskError,
  GetCanvasStateData,
  GetCanvasStateError,
  GetCanvasTransactionsData,
  GetCanvasTransactionsError,
  GetCodeArtifactDetailData,
  GetCodeArtifactDetailError,
  GetCollabTokenError,
  GetComposioConnectionStatusData,
  GetComposioConnectionStatusError,
  GetCopilotSessionDetailData,
  GetCopilotSessionDetailError,
  GetCreditBalanceError,
  GetCreditRechargeData,
  GetCreditRechargeError,
  GetCreditUsageByCanvasIdData,
  GetCreditUsageByCanvasIdError,
  GetCreditUsageByExecutionIdData,
  GetCreditUsageByExecutionIdError,
  GetCreditUsageByResultIdData,
  GetCreditUsageByResultIdError,
  GetCreditUsageData,
  GetCreditUsageError,
  GetDocumentDetailData,
  GetDocumentDetailError,
  GetExportJobStatusData,
  GetExportJobStatusError,
  GetFormDefinitionError,
  GetMediaLibraryDownloadTaskData,
  GetMediaLibraryDownloadTaskError,
  GetMediaLibraryEntryAccessUrlData,
  GetMediaLibraryEntryAccessUrlError,
  GetMediaLibraryEntryData,
  GetMediaLibraryEntryError,
  GetMediaLibraryUploadStatusData,
  GetMediaLibraryUploadStatusError,
  GetModelOptionsError,
  GetOpenapiConfigData,
  GetOpenapiConfigError,
  GetPageByCanvasIdData,
  GetPageByCanvasIdError,
  GetPageDetailData,
  GetPageDetailError,
  GetPayOrderData,
  GetPayOrderError,
  GetPilotSessionDetailData,
  GetPilotSessionDetailError,
  GetProductionStudioBatchData,
  GetProductionStudioBatchError,
  GetProductionStudioOutputAccessUrlData,
  GetProductionStudioOutputAccessUrlError,
  GetProductionStudioOutputStrategyArtifactData,
  GetProductionStudioOutputStrategyArtifactError,
  GetProductionStudioWorkspaceData,
  GetProductionStudioWorkspaceError,
  GetProjectDetailData,
  GetProjectDetailError,
  GetPromptSkillDetailData,
  GetPromptSkillDetailError,
  GetPromptSuggestionsError,
  GetRecordSnapshotData,
  GetRecordSnapshotError,
  GetResourceDetailData,
  GetResourceDetailError,
  GetScheduleDetailData,
  GetScheduleDetailError,
  GetScheduleRecordDetailData,
  GetScheduleRecordDetailError,
  GetScheduleRecordsData,
  GetScheduleRecordsError,
  GetSettingsError,
  GetSocialAccountCategoryData,
  GetSocialAccountCategoryError,
  GetSocialAccountData,
  GetSocialAccountError,
  GetSocialAccountLoginBatchStatusData,
  GetSocialAccountLoginBatchStatusError,
  GetSocialAccountOverviewError,
  GetSocialAccountWorkflowsData,
  GetSocialAccountWorkflowsError,
  GetSocialBrowserSessionBatchData,
  GetSocialBrowserSessionBatchError,
  GetSocialBrowserSessionData,
  GetSocialBrowserSessionError,
  GetSocialPublishExecutorStatusError,
  GetSubscriptionPlansError,
  GetSubscriptionUsageError,
  GetTemplateGenerationStatusData,
  GetTemplateGenerationStatusError,
  GetToolCallResultData,
  GetToolCallResultError,
  GetVideoEditAssetAccessUrlData,
  GetVideoEditAssetAccessUrlError,
  GetVideoEditProjectData,
  GetVideoEditProjectError,
  GetVideoEditProjectSnapshotData,
  GetVideoEditProjectSnapshotError,
  GetVideoEditVersionData,
  GetVideoEditVersionError,
  GetWorkflowAppDetailData,
  GetWorkflowAppDetailError,
  GetWorkflowDetailData,
  GetWorkflowDetailError,
  GetWorkflowDetailViaApiData,
  GetWorkflowDetailViaApiError,
  GetWorkflowOutputData,
  GetWorkflowOutputError,
  GetWorkflowPlanDetailData,
  GetWorkflowPlanDetailError,
  GetWorkflowSkillData,
  GetWorkflowSkillError,
  GetWorkflowStatusViaApiData,
  GetWorkflowStatusViaApiError,
  GetWorkflowVariablesData,
  GetWorkflowVariablesError,
  HasBeenInvitedError,
  HasFilledFormError,
  ImportCanvasData,
  ImportCanvasError,
  ImportCanvasMaterialsFromLibraryData,
  ImportCanvasMaterialsFromLibraryError,
  ImportCanvasMaterialsToLibraryData,
  ImportCanvasMaterialsToLibraryError,
  ImportProductionStudioClientPackData,
  ImportProductionStudioClientPackError,
  ImportProductionStudioScriptsData,
  ImportProductionStudioScriptsError,
  ImportSocialBrowserStateData,
  ImportSocialBrowserStateError,
  ImportSocialBrowserStateFileData,
  ImportSocialBrowserStateFileError,
  InitializeMediaLibraryUploadData,
  InitializeMediaLibraryUploadError,
  InitializeWorkflowData,
  InitializeWorkflowError,
  InvokeSkillData,
  InvokeSkillError,
  InvokeWorkflowSkillData,
  InvokeWorkflowSkillError,
  IssueSocialBrowserStateExportTicketData,
  IssueSocialBrowserStateExportTicketError,
  IssueSocialBrowserViewerTicketData,
  IssueSocialBrowserViewerTicketError,
  ListAllScheduleRecordsData,
  ListAllScheduleRecordsError,
  ListCanvasesData,
  ListCanvasesError,
  ListCanvasMaterialsData,
  ListCanvasMaterialsError,
  ListCanvasTemplateCategoriesError,
  ListCanvasTemplatesData,
  ListCanvasTemplatesError,
  ListCategoriesBySocialAccountData,
  ListCategoriesBySocialAccountError,
  ListCliApiKeysError,
  ListCodeArtifactsData,
  ListCodeArtifactsError,
  ListCopilotSessionsData,
  ListCopilotSessionsError,
  ListDocumentsData,
  ListDocumentsError,
  ListDriveFilesData,
  ListDriveFilesError,
  ListInvitationCodesError,
  ListLabelClassesData,
  ListLabelClassesError,
  ListLabelInstancesData,
  ListLabelInstancesError,
  ListManagedModelsData,
  ListManagedModelsError,
  ListMcpServersData,
  ListMcpServersError,
  ListMediaLibraryEntriesData,
  ListMediaLibraryEntriesError,
  ListModelsError,
  ListPagesData,
  ListPagesError,
  ListPilotSessionsData,
  ListPilotSessionsError,
  ListProductionStudioClientPacksError,
  ListProjectsData,
  ListProjectsError,
  ListPromptSkillsData,
  ListPromptSkillsError,
  ListProviderItemOptionsData,
  ListProviderItemOptionsError,
  ListProviderItemsData,
  ListProviderItemsError,
  ListProvidersData,
  ListProvidersError,
  ListResourcesData,
  ListResourcesError,
  ListSchedulesData,
  ListSchedulesError,
  ListSharesData,
  ListSharesError,
  ListSkillInstancesData,
  ListSkillInstancesError,
  ListSkillsError,
  ListSkillTriggersData,
  ListSkillTriggersError,
  ListSocialAccountCategoriesError,
  ListSocialAccountsByCategoryData,
  ListSocialAccountsByCategoryError,
  ListSocialAccountsData,
  ListSocialAccountsError,
  ListSocialPlatformsError,
  ListToolsData,
  ListToolsError,
  ListToolsetInventoryError,
  ListToolsetsData,
  ListToolsetsError,
  ListUserToolsError,
  ListUserVouchersError,
  ListWorkflowAppsData,
  ListWorkflowAppsError,
  ListWorkflowExecutionsData,
  ListWorkflowExecutionsError,
  ListWorkflowSkillsError,
  LogoutError,
  ManualBindSocialAccountsData,
  ManualBindSocialAccountsError,
  MaterializeCopilotSessionData,
  MaterializeCopilotSessionError,
  MoveSocialAccountsCategoryData,
  MoveSocialAccountsCategoryError,
  MultiLingualWebSearchData,
  MultiLingualWebSearchError,
  OpenSocialBrowserViewerConnectionData,
  OpenSocialBrowserViewerConnectionError,
  PauseProductionStudioBatchData,
  PauseProductionStudioBatchError,
  PinSkillInstanceData,
  PinSkillInstanceError,
  RecognizeSocialAccountsData,
  RecognizeSocialAccountsError,
  RecoverPilotSessionData,
  RecoverPilotSessionError,
  RefreshTokenError,
  RegenerateProductionStudioScriptsData,
  RegenerateProductionStudioScriptsError,
  RegenerateVideoEditNarrativeData,
  RegenerateVideoEditNarrativeError,
  ReindexResourceData,
  ReindexResourceError,
  ResendVerificationData,
  ResendVerificationError,
  RestartWorkflowNodeData,
  RestartWorkflowNodeError,
  RetryScheduleRecordData,
  RetryScheduleRecordError,
  ReviewProductionStudioOutputData,
  ReviewProductionStudioOutputError,
  RevokeCliApiKeyData,
  RevokeCliApiKeyError,
  RevokeComposioConnectionData,
  RevokeComposioConnectionError,
  RunWorkflowViaApiData,
  RunWorkflowViaApiError,
  SaveOneSocialAccountLoginBatchData,
  SaveOneSocialAccountLoginBatchError,
  SaveProductionStudioScriptData,
  SaveProductionStudioScriptError,
  SaveSocialAccountLoginCookiesData,
  SaveSocialAccountLoginCookiesError,
  SaveSocialBrowserStateData,
  SaveSocialBrowserStateError,
  SaveVideoEditProjectSnapshotData,
  SaveVideoEditProjectSnapshotError,
  ScrapeData,
  ScrapeError,
  SearchData,
  SearchError,
  SearchMediaLibraryEntriesData,
  SearchMediaLibraryEntriesError,
  SearchWorkflowsViaApiData,
  SearchWorkflowsViaApiError,
  ServeStaticData,
  ServeStaticError,
  SetCanvasStateData,
  SetCanvasStateError,
  SetSocialBrowserSessionAutomationData,
  SetSocialBrowserSessionAutomationError,
  SharePageData,
  SharePageError,
  SignMediaLibraryUploadPartsData,
  SignMediaLibraryUploadPartsError,
  StartExportJobData,
  StartExportJobError,
  StartProductionStudioBatchData,
  StartProductionStudioBatchError,
  StartSocialAccountInteractiveLoginData,
  StartSocialAccountInteractiveLoginError,
  StartSocialAccountLoginBatchData,
  StartSocialAccountLoginBatchError,
  StartSocialAccountReloginBatchData,
  StartSocialAccountReloginBatchError,
  StopPublishTaskData,
  StopPublishTaskError,
  StopSocialAccountLoginBatchData,
  StopSocialAccountLoginBatchError,
  StreamInvokeSkillData,
  StreamInvokeSkillError,
  SubmitFormData,
  SubmitFormError,
  SyncCanvasStateData,
  SyncCanvasStateError,
  TestProviderConnectionData,
  TestProviderConnectionError,
  TogglePromptSkillData,
  TogglePromptSkillError,
  TriggerScheduleManuallyData,
  TriggerScheduleManuallyError,
  UnbindSocialAccountFromCategoryData,
  UnbindSocialAccountFromCategoryError,
  UnpinSkillInstanceData,
  UnpinSkillInstanceError,
  UpdateCanvasData,
  UpdateCanvasError,
  UpdateCanvasTemplateData,
  UpdateCanvasTemplateError,
  UpdateCliApiKeyData,
  UpdateCliApiKeyError,
  UpdateCodeArtifactData,
  UpdateCodeArtifactError,
  UpdateDocumentData,
  UpdateDocumentError,
  UpdateDriveFileData,
  UpdateDriveFileError,
  UpdateLabelClassData,
  UpdateLabelClassError,
  UpdateLabelInstanceData,
  UpdateLabelInstanceError,
  UpdateManagedModelData,
  UpdateManagedModelError,
  UpdateManagedModelStatusData,
  UpdateManagedModelStatusError,
  UpdateMcpServerData,
  UpdateMcpServerError,
  UpdateMediaLibraryEntryData,
  UpdateMediaLibraryEntryError,
  UpdateOpenapiConfigData,
  UpdateOpenapiConfigError,
  UpdatePageData,
  UpdatePageError,
  UpdatePilotSessionData,
  UpdatePilotSessionError,
  UpdateProductionStudioBatchData,
  UpdateProductionStudioBatchError,
  UpdateProductionStudioClientPackAssetData,
  UpdateProductionStudioClientPackAssetError,
  UpdateProductionStudioClientPackStatusData,
  UpdateProductionStudioClientPackStatusError,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectItemsData,
  UpdateProjectItemsError,
  UpdatePromptSkillData,
  UpdatePromptSkillError,
  UpdateProviderData,
  UpdateProviderError,
  UpdateProviderItemData,
  UpdateProviderItemError,
  UpdateResourceData,
  UpdateResourceError,
  UpdateScheduleData,
  UpdateScheduleError,
  UpdateSettingsData,
  UpdateSettingsError,
  UpdateSkillInstanceData,
  UpdateSkillInstanceError,
  UpdateSkillTriggerData,
  UpdateSkillTriggerError,
  UpdateSocialAccountCategoryData,
  UpdateSocialAccountCategoryError,
  UpdateSocialAccountCredentialData,
  UpdateSocialAccountCredentialError,
  UpdateSocialAccountProfileData,
  UpdateSocialAccountProfileError,
  UpdateSocialAccountRemarkData,
  UpdateSocialAccountRemarkError,
  UpdateSocialAccountStatusData,
  UpdateSocialAccountStatusError,
  UpdateToolsetData,
  UpdateToolsetError,
  UpdateWorkflowVariablesData,
  UpdateWorkflowVariablesError,
  UploadData,
  UploadError,
  UploadOpenapiFilesData,
  UploadOpenapiFilesError,
  ValidateMcpServerData,
  ValidateMcpServerError,
  ValidateVoucherData,
  ValidateVoucherError,
  VerifyVoucherInvitationData,
  VerifyVoucherInvitationError,
} from '../requests/types.gen';
import * as Common from './common';
export const useGetSocialAccountOverview = <
  TData = Common.GetSocialAccountOverviewDefaultResponse,
  TError = GetSocialAccountOverviewError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialAccountOverviewKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialAccountOverview({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useCheckSocialAccountInteractiveLogin = <
  TData = Common.CheckSocialAccountInteractiveLoginDefaultResponse,
  TError = CheckSocialAccountInteractiveLoginError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<CheckSocialAccountInteractiveLoginData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCheckSocialAccountInteractiveLoginKeyFn(clientOptions, queryKey),
    queryFn: () =>
      checkSocialAccountInteractiveLogin({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialAccountLoginBatchStatus = <
  TData = Common.GetSocialAccountLoginBatchStatusDefaultResponse,
  TError = GetSocialAccountLoginBatchStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialAccountLoginBatchStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialAccountLoginBatchStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialAccountLoginBatchStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListWorkflowSkills = <
  TData = Common.ListWorkflowSkillsDefaultResponse,
  TError = ListWorkflowSkillsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListWorkflowSkillsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listWorkflowSkills({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowSkill = <
  TData = Common.GetWorkflowSkillDefaultResponse,
  TError = GetWorkflowSkillError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowSkillData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowSkillKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowSkill({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSocialPlatforms = <
  TData = Common.ListSocialPlatformsDefaultResponse,
  TError = ListSocialPlatformsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSocialPlatformsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSocialPlatforms({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSocialAccounts = <
  TData = Common.ListSocialAccountsDefaultResponse,
  TError = ListSocialAccountsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListSocialAccountsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSocialAccountsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSocialAccounts({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialAccount = <
  TData = Common.GetSocialAccountDefaultResponse,
  TError = GetSocialAccountError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialAccountData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialAccountKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialAccount({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialAccountWorkflows = <
  TData = Common.GetSocialAccountWorkflowsDefaultResponse,
  TError = GetSocialAccountWorkflowsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialAccountWorkflowsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialAccountWorkflowsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialAccountWorkflows({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useExportSocialBrowserState = <
  TData = Common.ExportSocialBrowserStateDefaultResponse,
  TError = ExportSocialBrowserStateError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ExportSocialBrowserStateData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseExportSocialBrowserStateKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportSocialBrowserState({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSocialAccountCategories = <
  TData = Common.ListSocialAccountCategoriesDefaultResponse,
  TError = ListSocialAccountCategoriesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSocialAccountCategoriesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSocialAccountCategories({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialAccountCategory = <
  TData = Common.GetSocialAccountCategoryDefaultResponse,
  TError = GetSocialAccountCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialAccountCategoryData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialAccountCategoryKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialAccountCategory({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSocialAccountsByCategory = <
  TData = Common.ListSocialAccountsByCategoryDefaultResponse,
  TError = ListSocialAccountsByCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListSocialAccountsByCategoryData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSocialAccountsByCategoryKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSocialAccountsByCategory({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCategoriesBySocialAccount = <
  TData = Common.ListCategoriesBySocialAccountDefaultResponse,
  TError = ListCategoriesBySocialAccountError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCategoriesBySocialAccountData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCategoriesBySocialAccountKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCategoriesBySocialAccount({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetVideoEditProject = <
  TData = Common.GetVideoEditProjectDefaultResponse,
  TError = GetVideoEditProjectError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetVideoEditProjectData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetVideoEditProjectKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getVideoEditProject({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetVideoEditVersion = <
  TData = Common.GetVideoEditVersionDefaultResponse,
  TError = GetVideoEditVersionError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetVideoEditVersionData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetVideoEditVersionKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getVideoEditVersion({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetVideoEditProjectSnapshot = <
  TData = Common.GetVideoEditProjectSnapshotDefaultResponse,
  TError = GetVideoEditProjectSnapshotError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetVideoEditProjectSnapshotData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetVideoEditProjectSnapshotKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getVideoEditProjectSnapshot({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetVideoEditAssetAccessUrl = <
  TData = Common.GetVideoEditAssetAccessUrlDefaultResponse,
  TError = GetVideoEditAssetAccessUrlError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetVideoEditAssetAccessUrlData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetVideoEditAssetAccessUrlKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getVideoEditAssetAccessUrl({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetProductionStudioWorkspace = <
  TData = Common.GetProductionStudioWorkspaceDefaultResponse,
  TError = GetProductionStudioWorkspaceError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetProductionStudioWorkspaceData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetProductionStudioWorkspaceKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getProductionStudioWorkspace({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListProductionStudioClientPacks = <
  TData = Common.ListProductionStudioClientPacksDefaultResponse,
  TError = ListProductionStudioClientPacksError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListProductionStudioClientPacksKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listProductionStudioClientPacks({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetProductionStudioBatch = <
  TData = Common.GetProductionStudioBatchDefaultResponse,
  TError = GetProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetProductionStudioBatchData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetProductionStudioBatchKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getProductionStudioBatch({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetProductionStudioOutputAccessUrl = <
  TData = Common.GetProductionStudioOutputAccessUrlDefaultResponse,
  TError = GetProductionStudioOutputAccessUrlError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetProductionStudioOutputAccessUrlData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetProductionStudioOutputAccessUrlKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getProductionStudioOutputAccessUrl({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetProductionStudioOutputStrategyArtifact = <
  TData = Common.GetProductionStudioOutputStrategyArtifactDefaultResponse,
  TError = GetProductionStudioOutputStrategyArtifactError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetProductionStudioOutputStrategyArtifactData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetProductionStudioOutputStrategyArtifactKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getProductionStudioOutputStrategyArtifact({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialBrowserSession = <
  TData = Common.GetSocialBrowserSessionDefaultResponse,
  TError = GetSocialBrowserSessionError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialBrowserSessionData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialBrowserSessionKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialBrowserSession({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetActiveSocialBrowserSessionBatch = <
  TData = Common.GetActiveSocialBrowserSessionBatchDefaultResponse,
  TError = GetActiveSocialBrowserSessionBatchError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetActiveSocialBrowserSessionBatchKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getActiveSocialBrowserSessionBatch({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialBrowserSessionBatch = <
  TData = Common.GetSocialBrowserSessionBatchDefaultResponse,
  TError = GetSocialBrowserSessionBatchError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetSocialBrowserSessionBatchData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialBrowserSessionBatchKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialBrowserSessionBatch({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSocialPublishExecutorStatus = <
  TData = Common.GetSocialPublishExecutorStatusDefaultResponse,
  TError = GetSocialPublishExecutorStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSocialPublishExecutorStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSocialPublishExecutorStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListMediaLibraryEntries = <
  TData = Common.ListMediaLibraryEntriesDefaultResponse,
  TError = ListMediaLibraryEntriesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListMediaLibraryEntriesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListMediaLibraryEntriesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listMediaLibraryEntries({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useSearchMediaLibraryEntries = <
  TData = Common.SearchMediaLibraryEntriesDefaultResponse,
  TError = SearchMediaLibraryEntriesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<SearchMediaLibraryEntriesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSearchMediaLibraryEntriesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      searchMediaLibraryEntries({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetMediaLibraryEntry = <
  TData = Common.GetMediaLibraryEntryDefaultResponse,
  TError = GetMediaLibraryEntryError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetMediaLibraryEntryData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetMediaLibraryEntryKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getMediaLibraryEntry({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetMediaLibraryEntryAccessUrl = <
  TData = Common.GetMediaLibraryEntryAccessUrlDefaultResponse,
  TError = GetMediaLibraryEntryAccessUrlError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetMediaLibraryEntryAccessUrlData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetMediaLibraryEntryAccessUrlKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getMediaLibraryEntryAccessUrl({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetMediaLibraryUploadStatus = <
  TData = Common.GetMediaLibraryUploadStatusDefaultResponse,
  TError = GetMediaLibraryUploadStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetMediaLibraryUploadStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetMediaLibraryUploadStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getMediaLibraryUploadStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetMediaLibraryDownloadTask = <
  TData = Common.GetMediaLibraryDownloadTaskDefaultResponse,
  TError = GetMediaLibraryDownloadTaskError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetMediaLibraryDownloadTaskData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetMediaLibraryDownloadTaskKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getMediaLibraryDownloadTask({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCanvasMaterials = <
  TData = Common.ListCanvasMaterialsDefaultResponse,
  TError = ListCanvasMaterialsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCanvasMaterialsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCanvasMaterialsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCanvasMaterials({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasMaterialAccessUrl = <
  TData = Common.GetCanvasMaterialAccessUrlDefaultResponse,
  TError = GetCanvasMaterialAccessUrlError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasMaterialAccessUrlData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasMaterialAccessUrlKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasMaterialAccessUrl({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasMaterialDownloadTask = <
  TData = Common.GetCanvasMaterialDownloadTaskDefaultResponse,
  TError = GetCanvasMaterialDownloadTaskError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasMaterialDownloadTaskData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasMaterialDownloadTaskKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasMaterialDownloadTask({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListMcpServers = <
  TData = Common.ListMcpServersDefaultResponse,
  TError = ListMcpServersError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListMcpServersData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListMcpServersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listMcpServers({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListPages = <
  TData = Common.ListPagesDefaultResponse,
  TError = ListPagesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListPagesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListPagesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listPages({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPageDetail = <
  TData = Common.GetPageDetailDefaultResponse,
  TError = GetPageDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetPageDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPageDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPageDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPageByCanvasId = <
  TData = Common.GetPageByCanvasIdDefaultResponse,
  TError = GetPageByCanvasIdError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetPageByCanvasIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPageByCanvasIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPageByCanvasId({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetAuthConfig = <
  TData = Common.GetAuthConfigDefaultResponse,
  TError = GetAuthConfigError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetAuthConfigKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAuthConfig({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useCheckToolOauthStatus = <
  TData = Common.CheckToolOauthStatusDefaultResponse,
  TError = CheckToolOauthStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<CheckToolOauthStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCheckToolOauthStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      checkToolOauthStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCollabToken = <
  TData = Common.GetCollabTokenDefaultResponse,
  TError = GetCollabTokenError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCollabTokenKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCollabToken({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCanvases = <
  TData = Common.ListCanvasesDefaultResponse,
  TError = ListCanvasesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCanvasesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCanvasesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCanvases({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasDetail = <
  TData = Common.GetCanvasDetailDefaultResponse,
  TError = GetCanvasDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasData = <
  TData = Common.GetCanvasDataDefaultResponse,
  TError = GetCanvasDataError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasDataData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasDataKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasData({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useExportCanvas = <
  TData = Common.ExportCanvasDefaultResponse,
  TError = ExportCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ExportCanvasData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseExportCanvasKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportCanvas({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasState = <
  TData = Common.GetCanvasStateDefaultResponse,
  TError = GetCanvasStateError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasStateData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasStateKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasState({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCanvasTransactions = <
  TData = Common.GetCanvasTransactionsDefaultResponse,
  TError = GetCanvasTransactionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCanvasTransactionsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCanvasTransactionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCanvasTransactions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowVariables = <
  TData = Common.GetWorkflowVariablesDefaultResponse,
  TError = GetWorkflowVariablesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowVariablesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowVariablesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowVariables({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListDriveFiles = <
  TData = Common.ListDriveFilesDefaultResponse,
  TError = ListDriveFilesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListDriveFilesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListDriveFilesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listDriveFiles({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCanvasTemplates = <
  TData = Common.ListCanvasTemplatesDefaultResponse,
  TError = ListCanvasTemplatesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCanvasTemplatesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCanvasTemplatesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCanvasTemplates({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCanvasTemplateCategories = <
  TData = Common.ListCanvasTemplateCategoriesDefaultResponse,
  TError = ListCanvasTemplateCategoriesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCanvasTemplateCategoriesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCanvasTemplateCategories({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListResources = <
  TData = Common.ListResourcesDefaultResponse,
  TError = ListResourcesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListResourcesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListResourcesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listResources({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetResourceDetail = <
  TData = Common.GetResourceDetailDefaultResponse,
  TError = GetResourceDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetResourceDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetResourceDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getResourceDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListDocuments = <
  TData = Common.ListDocumentsDefaultResponse,
  TError = ListDocumentsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListDocumentsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListDocumentsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listDocuments({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetDocumentDetail = <
  TData = Common.GetDocumentDetailDefaultResponse,
  TError = GetDocumentDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetDocumentDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetDocumentDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getDocumentDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useExportDocument = <
  TData = Common.ExportDocumentDefaultResponse,
  TError = ExportDocumentError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ExportDocumentData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseExportDocumentKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportDocument({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetExportJobStatus = <
  TData = Common.GetExportJobStatusDefaultResponse,
  TError = GetExportJobStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetExportJobStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetExportJobStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getExportJobStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useDownloadExportJobResult = <
  TData = Common.DownloadExportJobResultDefaultResponse,
  TError = DownloadExportJobResultError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<DownloadExportJobResultData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDownloadExportJobResultKeyFn(clientOptions, queryKey),
    queryFn: () =>
      downloadExportJobResult({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListProjects = <
  TData = Common.ListProjectsDefaultResponse,
  TError = ListProjectsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListProjectsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListProjectsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listProjects({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetProjectDetail = <
  TData = Common.GetProjectDetailDefaultResponse,
  TError = GetProjectDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetProjectDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetProjectDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getProjectDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCodeArtifacts = <
  TData = Common.ListCodeArtifactsDefaultResponse,
  TError = ListCodeArtifactsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCodeArtifactsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCodeArtifactsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCodeArtifacts({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCodeArtifactDetail = <
  TData = Common.GetCodeArtifactDetailDefaultResponse,
  TError = GetCodeArtifactDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCodeArtifactDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCodeArtifactDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCodeArtifactDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListShares = <
  TData = Common.ListSharesDefaultResponse,
  TError = ListSharesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListSharesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSharesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listShares({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListLabelClasses = <
  TData = Common.ListLabelClassesDefaultResponse,
  TError = ListLabelClassesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListLabelClassesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListLabelClassesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listLabelClasses({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListLabelInstances = <
  TData = Common.ListLabelInstancesDefaultResponse,
  TError = ListLabelInstancesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListLabelInstancesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListLabelInstancesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listLabelInstances({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetActionResult = <
  TData = Common.GetActionResultDefaultResponse,
  TError = GetActionResultError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetActionResultData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetActionResultKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getActionResult({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSkills = <
  TData = Common.ListSkillsDefaultResponse,
  TError = ListSkillsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSkillsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSkills({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSkillInstances = <
  TData = Common.ListSkillInstancesDefaultResponse,
  TError = ListSkillInstancesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListSkillInstancesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSkillInstancesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSkillInstances({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListSkillTriggers = <
  TData = Common.ListSkillTriggersDefaultResponse,
  TError = ListSkillTriggersError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListSkillTriggersData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListSkillTriggersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listSkillTriggers({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListPilotSessions = <
  TData = Common.ListPilotSessionsDefaultResponse,
  TError = ListPilotSessionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListPilotSessionsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListPilotSessionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listPilotSessions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPilotSessionDetail = <
  TData = Common.GetPilotSessionDetailDefaultResponse,
  TError = GetPilotSessionDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetPilotSessionDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPilotSessionDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPilotSessionDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCopilotSessions = <
  TData = Common.ListCopilotSessionsDefaultResponse,
  TError = ListCopilotSessionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListCopilotSessionsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCopilotSessionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCopilotSessions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCopilotSessionDetail = <
  TData = Common.GetCopilotSessionDetailDefaultResponse,
  TError = GetCopilotSessionDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCopilotSessionDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCopilotSessionDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCopilotSessionDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListWorkflowExecutions = <
  TData = Common.ListWorkflowExecutionsDefaultResponse,
  TError = ListWorkflowExecutionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListWorkflowExecutionsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListWorkflowExecutionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listWorkflowExecutions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowDetail = <
  TData = Common.GetWorkflowDetailDefaultResponse,
  TError = GetWorkflowDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowPlanDetail = <
  TData = Common.GetWorkflowPlanDetailDefaultResponse,
  TError = GetWorkflowPlanDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowPlanDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowPlanDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowPlanDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowAppDetail = <
  TData = Common.GetWorkflowAppDetailDefaultResponse,
  TError = GetWorkflowAppDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowAppDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowAppDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowAppDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListWorkflowApps = <
  TData = Common.ListWorkflowAppsDefaultResponse,
  TError = ListWorkflowAppsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListWorkflowAppsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListWorkflowAppsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listWorkflowApps({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetTemplateGenerationStatus = <
  TData = Common.GetTemplateGenerationStatusDefaultResponse,
  TError = GetTemplateGenerationStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetTemplateGenerationStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetTemplateGenerationStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getTemplateGenerationStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListCliApiKeys = <
  TData = Common.ListCliApiKeysDefaultResponse,
  TError = ListCliApiKeysError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListCliApiKeysKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listCliApiKeys({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetOpenapiConfig = <
  TData = Common.GetOpenapiConfigDefaultResponse,
  TError = GetOpenapiConfigError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetOpenapiConfigData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetOpenapiConfigKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOpenapiConfig({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useSearchWorkflowsViaApi = <
  TData = Common.SearchWorkflowsViaApiDefaultResponse,
  TError = SearchWorkflowsViaApiError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<SearchWorkflowsViaApiData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSearchWorkflowsViaApiKeyFn(clientOptions, queryKey),
    queryFn: () =>
      searchWorkflowsViaApi({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowDetailViaApi = <
  TData = Common.GetWorkflowDetailViaApiDefaultResponse,
  TError = GetWorkflowDetailViaApiError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowDetailViaApiData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowDetailViaApiKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowDetailViaApi({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowStatusViaApi = <
  TData = Common.GetWorkflowStatusViaApiDefaultResponse,
  TError = GetWorkflowStatusViaApiError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowStatusViaApiData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowStatusViaApiKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowStatusViaApi({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetWorkflowOutput = <
  TData = Common.GetWorkflowOutputDefaultResponse,
  TError = GetWorkflowOutputError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetWorkflowOutputData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetWorkflowOutputKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getWorkflowOutput({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSettings = <
  TData = Common.GetSettingsDefaultResponse,
  TError = GetSettingsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSettingsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSettings({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useCheckSettingsField = <
  TData = Common.CheckSettingsFieldDefaultResponse,
  TError = CheckSettingsFieldError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<CheckSettingsFieldData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCheckSettingsFieldKeyFn(clientOptions, queryKey),
    queryFn: () =>
      checkSettingsField({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetFormDefinition = <
  TData = Common.GetFormDefinitionDefaultResponse,
  TError = GetFormDefinitionError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetFormDefinitionKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getFormDefinition({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useHasFilledForm = <
  TData = Common.HasFilledFormDefaultResponse,
  TError = HasFilledFormError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHasFilledFormKeyFn(clientOptions, queryKey),
    queryFn: () =>
      hasFilledForm({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditRecharge = <
  TData = Common.GetCreditRechargeDefaultResponse,
  TError = GetCreditRechargeError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCreditRechargeData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditRechargeKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditRecharge({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditUsage = <
  TData = Common.GetCreditUsageDefaultResponse,
  TError = GetCreditUsageError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCreditUsageData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditUsageKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditUsage({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditBalance = <
  TData = Common.GetCreditBalanceDefaultResponse,
  TError = GetCreditBalanceError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditBalanceKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditBalance({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditUsageByResultId = <
  TData = Common.GetCreditUsageByResultIdDefaultResponse,
  TError = GetCreditUsageByResultIdError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCreditUsageByResultIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditUsageByResultIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditUsageByResultId({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditUsageByExecutionId = <
  TData = Common.GetCreditUsageByExecutionIdDefaultResponse,
  TError = GetCreditUsageByExecutionIdError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCreditUsageByExecutionIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditUsageByExecutionIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditUsageByExecutionId({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetCreditUsageByCanvasId = <
  TData = Common.GetCreditUsageByCanvasIdDefaultResponse,
  TError = GetCreditUsageByCanvasIdError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetCreditUsageByCanvasIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetCreditUsageByCanvasIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCreditUsageByCanvasId({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListInvitationCodes = <
  TData = Common.ListInvitationCodesDefaultResponse,
  TError = ListInvitationCodesError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListInvitationCodesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listInvitationCodes({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useHasBeenInvited = <
  TData = Common.HasBeenInvitedDefaultResponse,
  TError = HasBeenInvitedError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHasBeenInvitedKeyFn(clientOptions, queryKey),
    queryFn: () =>
      hasBeenInvited({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSubscriptionPlans = <
  TData = Common.GetSubscriptionPlansDefaultResponse,
  TError = GetSubscriptionPlansError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSubscriptionPlansKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSubscriptionPlans({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetSubscriptionUsage = <
  TData = Common.GetSubscriptionUsageDefaultResponse,
  TError = GetSubscriptionUsageError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetSubscriptionUsageKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSubscriptionUsage({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListModels = <
  TData = Common.ListModelsDefaultResponse,
  TError = ListModelsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListModelsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listModels({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPayOrder = <
  TData = Common.GetPayOrderDefaultResponse,
  TError = GetPayOrderError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetPayOrderData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPayOrderKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPayOrder({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetModelOptions = <
  TData = Common.GetModelOptionsDefaultResponse,
  TError = GetModelOptionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetModelOptionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getModelOptions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListManagedModels = <
  TData = Common.ListManagedModelsDefaultResponse,
  TError = ListManagedModelsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListManagedModelsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListManagedModelsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listManagedModels({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListProviders = <
  TData = Common.ListProvidersDefaultResponse,
  TError = ListProvidersError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListProvidersData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListProvidersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listProviders({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListProviderItems = <
  TData = Common.ListProviderItemsDefaultResponse,
  TError = ListProviderItemsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListProviderItemsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListProviderItemsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listProviderItems({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListProviderItemOptions = <
  TData = Common.ListProviderItemOptionsDefaultResponse,
  TError = ListProviderItemOptionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListProviderItemOptionsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListProviderItemOptionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listProviderItemOptions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListTools = <
  TData = Common.ListToolsDefaultResponse,
  TError = ListToolsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListToolsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListToolsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listTools({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListUserTools = <
  TData = Common.ListUserToolsDefaultResponse,
  TError = ListUserToolsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListUserToolsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listUserTools({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListToolsetInventory = <
  TData = Common.ListToolsetInventoryDefaultResponse,
  TError = ListToolsetInventoryError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListToolsetInventoryKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listToolsetInventory({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListToolsets = <
  TData = Common.ListToolsetsDefaultResponse,
  TError = ListToolsetsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListToolsetsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListToolsetsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listToolsets({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useExportToolsetDefinitions = <
  TData = Common.ExportToolsetDefinitionsDefaultResponse,
  TError = ExportToolsetDefinitionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ExportToolsetDefinitionsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseExportToolsetDefinitionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportToolsetDefinitions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetToolCallResult = <
  TData = Common.GetToolCallResultDefaultResponse,
  TError = GetToolCallResultError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetToolCallResultData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetToolCallResultKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getToolCallResult({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetComposioConnectionStatus = <
  TData = Common.GetComposioConnectionStatusDefaultResponse,
  TError = GetComposioConnectionStatusError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetComposioConnectionStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetComposioConnectionStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getComposioConnectionStatus({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useServeStatic = <
  TData = Common.ServeStaticDefaultResponse,
  TError = ServeStaticError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ServeStaticData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseServeStaticKeyFn(clientOptions, queryKey),
    queryFn: () =>
      serveStatic({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPromptSuggestions = <
  TData = Common.GetPromptSuggestionsDefaultResponse,
  TError = GetPromptSuggestionsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPromptSuggestionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPromptSuggestions({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetAvailableVouchers = <
  TData = Common.GetAvailableVouchersDefaultResponse,
  TError = GetAvailableVouchersError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetAvailableVouchersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAvailableVouchers({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListUserVouchers = <
  TData = Common.ListUserVouchersDefaultResponse,
  TError = ListUserVouchersError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListUserVouchersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listUserVouchers({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useVerifyVoucherInvitation = <
  TData = Common.VerifyVoucherInvitationDefaultResponse,
  TError = VerifyVoucherInvitationError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<VerifyVoucherInvitationData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVerifyVoucherInvitationKeyFn(clientOptions, queryKey),
    queryFn: () =>
      verifyVoucherInvitation({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useListPromptSkills = <
  TData = Common.ListPromptSkillsDefaultResponse,
  TError = ListPromptSkillsError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<ListPromptSkillsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseListPromptSkillsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listPromptSkills({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useGetPromptSkillDetail = <
  TData = Common.GetPromptSkillDetailDefaultResponse,
  TError = GetPromptSkillDetailError,
  TQueryKey extends Array<unknown> = unknown[],
>(
  clientOptions: Options<GetPromptSkillDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGetPromptSkillDetailKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPromptSkillDetail({ ...clientOptions }).then(
        (response) => queryResponseData(response) as TData,
      ) as TData,
    ...options,
  });
export const useRecognizeSocialAccounts = <
  TData = Common.RecognizeSocialAccountsMutationResult,
  TError = RecognizeSocialAccountsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RecognizeSocialAccountsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RecognizeSocialAccountsData, true>, TContext>({
    mutationKey: Common.UseRecognizeSocialAccountsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      recognizeSocialAccounts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useManualBindSocialAccounts = <
  TData = Common.ManualBindSocialAccountsMutationResult,
  TError = ManualBindSocialAccountsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ManualBindSocialAccountsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ManualBindSocialAccountsData, true>, TContext>({
    mutationKey: Common.UseManualBindSocialAccountsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      manualBindSocialAccounts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStartSocialAccountInteractiveLogin = <
  TData = Common.StartSocialAccountInteractiveLoginMutationResult,
  TError = StartSocialAccountInteractiveLoginError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<StartSocialAccountInteractiveLoginData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StartSocialAccountInteractiveLoginData, true>, TContext>({
    mutationKey: Common.UseStartSocialAccountInteractiveLoginKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      startSocialAccountInteractiveLogin(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCompleteSocialAccountInteractiveLogin = <
  TData = Common.CompleteSocialAccountInteractiveLoginMutationResult,
  TError = CompleteSocialAccountInteractiveLoginError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CompleteSocialAccountInteractiveLoginData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CompleteSocialAccountInteractiveLoginData, true>, TContext>({
    mutationKey: Common.UseCompleteSocialAccountInteractiveLoginKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      completeSocialAccountInteractiveLogin(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSaveSocialAccountLoginCookies = <
  TData = Common.SaveSocialAccountLoginCookiesMutationResult,
  TError = SaveSocialAccountLoginCookiesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SaveSocialAccountLoginCookiesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SaveSocialAccountLoginCookiesData, true>, TContext>({
    mutationKey: Common.UseSaveSocialAccountLoginCookiesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      saveSocialAccountLoginCookies(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCloseSocialAccountLoginBrowser = <
  TData = Common.CloseSocialAccountLoginBrowserMutationResult,
  TError = CloseSocialAccountLoginBrowserError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CloseSocialAccountLoginBrowserData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CloseSocialAccountLoginBrowserData, true>, TContext>({
    mutationKey: Common.UseCloseSocialAccountLoginBrowserKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      closeSocialAccountLoginBrowser(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStartSocialAccountLoginBatch = <
  TData = Common.StartSocialAccountLoginBatchMutationResult,
  TError = StartSocialAccountLoginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StartSocialAccountLoginBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StartSocialAccountLoginBatchData, true>, TContext>({
    mutationKey: Common.UseStartSocialAccountLoginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      startSocialAccountLoginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useContinueSocialAccountLoginBatch = <
  TData = Common.ContinueSocialAccountLoginBatchMutationResult,
  TError = ContinueSocialAccountLoginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ContinueSocialAccountLoginBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ContinueSocialAccountLoginBatchData, true>, TContext>({
    mutationKey: Common.UseContinueSocialAccountLoginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      continueSocialAccountLoginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStopSocialAccountLoginBatch = <
  TData = Common.StopSocialAccountLoginBatchMutationResult,
  TError = StopSocialAccountLoginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StopSocialAccountLoginBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StopSocialAccountLoginBatchData, true>, TContext>({
    mutationKey: Common.UseStopSocialAccountLoginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      stopSocialAccountLoginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelOneSocialAccountLoginBatch = <
  TData = Common.CancelOneSocialAccountLoginBatchMutationResult,
  TError = CancelOneSocialAccountLoginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CancelOneSocialAccountLoginBatchData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CancelOneSocialAccountLoginBatchData, true>, TContext>({
    mutationKey: Common.UseCancelOneSocialAccountLoginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelOneSocialAccountLoginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSaveOneSocialAccountLoginBatch = <
  TData = Common.SaveOneSocialAccountLoginBatchMutationResult,
  TError = SaveOneSocialAccountLoginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SaveOneSocialAccountLoginBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SaveOneSocialAccountLoginBatchData, true>, TContext>({
    mutationKey: Common.UseSaveOneSocialAccountLoginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      saveOneSocialAccountLoginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateWorkflowSkill = <
  TData = Common.CreateWorkflowSkillMutationResult,
  TError = CreateWorkflowSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateWorkflowSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateWorkflowSkillData, true>, TContext>({
    mutationKey: Common.UseCreateWorkflowSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => createWorkflowSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteWorkflowSkill = <
  TData = Common.DeleteWorkflowSkillMutationResult,
  TError = DeleteWorkflowSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteWorkflowSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteWorkflowSkillData, true>, TContext>({
    mutationKey: Common.UseDeleteWorkflowSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteWorkflowSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useInvokeWorkflowSkill = <
  TData = Common.InvokeWorkflowSkillMutationResult,
  TError = InvokeWorkflowSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<InvokeWorkflowSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<InvokeWorkflowSkillData, true>, TContext>({
    mutationKey: Common.UseInvokeWorkflowSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => invokeWorkflowSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSocialAccount = <
  TData = Common.CreateSocialAccountMutationResult,
  TError = CreateSocialAccountError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSocialAccountData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSocialAccountData, true>, TContext>({
    mutationKey: Common.UseCreateSocialAccountKeyFn(mutationKey),
    mutationFn: (clientOptions) => createSocialAccount(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchCreateSocialAccounts = <
  TData = Common.BatchCreateSocialAccountsMutationResult,
  TError = BatchCreateSocialAccountsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchCreateSocialAccountsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchCreateSocialAccountsData, true>, TContext>({
    mutationKey: Common.UseBatchCreateSocialAccountsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchCreateSocialAccounts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSocialAccountAutoBindingBatch = <
  TData = Common.CreateSocialAccountAutoBindingBatchMutationResult,
  TError = CreateSocialAccountAutoBindingBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateSocialAccountAutoBindingBatchData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSocialAccountAutoBindingBatchData, true>, TContext>({
    mutationKey: Common.UseCreateSocialAccountAutoBindingBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createSocialAccountAutoBindingBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStartSocialAccountReloginBatch = <
  TData = Common.StartSocialAccountReloginBatchMutationResult,
  TError = StartSocialAccountReloginBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StartSocialAccountReloginBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StartSocialAccountReloginBatchData, true>, TContext>({
    mutationKey: Common.UseStartSocialAccountReloginBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      startSocialAccountReloginBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSocialAccountCredential = <
  TData = Common.UpdateSocialAccountCredentialMutationResult,
  TError = UpdateSocialAccountCredentialError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSocialAccountCredentialData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSocialAccountCredentialData, true>, TContext>({
    mutationKey: Common.UseUpdateSocialAccountCredentialKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateSocialAccountCredential(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSocialAccountProfile = <
  TData = Common.UpdateSocialAccountProfileMutationResult,
  TError = UpdateSocialAccountProfileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSocialAccountProfileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSocialAccountProfileData, true>, TContext>({
    mutationKey: Common.UseUpdateSocialAccountProfileKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateSocialAccountProfile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSocialAccountRemark = <
  TData = Common.UpdateSocialAccountRemarkMutationResult,
  TError = UpdateSocialAccountRemarkError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSocialAccountRemarkData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSocialAccountRemarkData, true>, TContext>({
    mutationKey: Common.UseUpdateSocialAccountRemarkKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateSocialAccountRemark(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSaveSocialBrowserState = <
  TData = Common.SaveSocialBrowserStateMutationResult,
  TError = SaveSocialBrowserStateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SaveSocialBrowserStateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SaveSocialBrowserStateData, true>, TContext>({
    mutationKey: Common.UseSaveSocialBrowserStateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      saveSocialBrowserState(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportSocialBrowserState = <
  TData = Common.ImportSocialBrowserStateMutationResult,
  TError = ImportSocialBrowserStateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ImportSocialBrowserStateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportSocialBrowserStateData, true>, TContext>({
    mutationKey: Common.UseImportSocialBrowserStateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importSocialBrowserState(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportSocialBrowserStateFile = <
  TData = Common.ImportSocialBrowserStateFileMutationResult,
  TError = ImportSocialBrowserStateFileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ImportSocialBrowserStateFileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportSocialBrowserStateFileData, true>, TContext>({
    mutationKey: Common.UseImportSocialBrowserStateFileKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importSocialBrowserStateFile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useIssueSocialBrowserStateExportTicket = <
  TData = Common.IssueSocialBrowserStateExportTicketMutationResult,
  TError = IssueSocialBrowserStateExportTicketError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<IssueSocialBrowserStateExportTicketData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<IssueSocialBrowserStateExportTicketData, true>, TContext>({
    mutationKey: Common.UseIssueSocialBrowserStateExportTicketKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      issueSocialBrowserStateExportTicket(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSocialAccountStatus = <
  TData = Common.UpdateSocialAccountStatusMutationResult,
  TError = UpdateSocialAccountStatusError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSocialAccountStatusData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSocialAccountStatusData, true>, TContext>({
    mutationKey: Common.UseUpdateSocialAccountStatusKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateSocialAccountStatus(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSocialAccountCategory = <
  TData = Common.CreateSocialAccountCategoryMutationResult,
  TError = CreateSocialAccountCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSocialAccountCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSocialAccountCategoryData, true>, TContext>({
    mutationKey: Common.UseCreateSocialAccountCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createSocialAccountCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSocialAccountCategory = <
  TData = Common.UpdateSocialAccountCategoryMutationResult,
  TError = UpdateSocialAccountCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSocialAccountCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSocialAccountCategoryData, true>, TContext>({
    mutationKey: Common.UseUpdateSocialAccountCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateSocialAccountCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBindSocialAccountToCategory = <
  TData = Common.BindSocialAccountToCategoryMutationResult,
  TError = BindSocialAccountToCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BindSocialAccountToCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BindSocialAccountToCategoryData, true>, TContext>({
    mutationKey: Common.UseBindSocialAccountToCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bindSocialAccountToCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchBindSocialAccountsToCategory = <
  TData = Common.BatchBindSocialAccountsToCategoryMutationResult,
  TError = BatchBindSocialAccountsToCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BatchBindSocialAccountsToCategoryData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchBindSocialAccountsToCategoryData, true>, TContext>({
    mutationKey: Common.UseBatchBindSocialAccountsToCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchBindSocialAccountsToCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchUnbindSocialAccountsFromCategory = <
  TData = Common.BatchUnbindSocialAccountsFromCategoryMutationResult,
  TError = BatchUnbindSocialAccountsFromCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BatchUnbindSocialAccountsFromCategoryData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchUnbindSocialAccountsFromCategoryData, true>, TContext>({
    mutationKey: Common.UseBatchUnbindSocialAccountsFromCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchUnbindSocialAccountsFromCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useMoveSocialAccountsCategory = <
  TData = Common.MoveSocialAccountsCategoryMutationResult,
  TError = MoveSocialAccountsCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<MoveSocialAccountsCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<MoveSocialAccountsCategoryData, true>, TContext>({
    mutationKey: Common.UseMoveSocialAccountsCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      moveSocialAccountsCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateVideoEditProject = <
  TData = Common.CreateVideoEditProjectMutationResult,
  TError = CreateVideoEditProjectError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateVideoEditProjectData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateVideoEditProjectData, true>, TContext>({
    mutationKey: Common.UseCreateVideoEditProjectKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createVideoEditProject(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useConfirmVideoEditNarrative = <
  TData = Common.ConfirmVideoEditNarrativeMutationResult,
  TError = ConfirmVideoEditNarrativeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ConfirmVideoEditNarrativeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ConfirmVideoEditNarrativeData, true>, TContext>({
    mutationKey: Common.UseConfirmVideoEditNarrativeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      confirmVideoEditNarrative(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRegenerateVideoEditNarrative = <
  TData = Common.RegenerateVideoEditNarrativeMutationResult,
  TError = RegenerateVideoEditNarrativeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RegenerateVideoEditNarrativeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RegenerateVideoEditNarrativeData, true>, TContext>({
    mutationKey: Common.UseRegenerateVideoEditNarrativeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      regenerateVideoEditNarrative(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAttachVideoEditProjectAssets = <
  TData = Common.AttachVideoEditProjectAssetsMutationResult,
  TError = AttachVideoEditProjectAssetsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AttachVideoEditProjectAssetsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AttachVideoEditProjectAssetsData, true>, TContext>({
    mutationKey: Common.UseAttachVideoEditProjectAssetsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      attachVideoEditProjectAssets(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCompleteVideoManualEdit = <
  TData = Common.CompleteVideoManualEditMutationResult,
  TError = CompleteVideoManualEditError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CompleteVideoManualEditData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CompleteVideoManualEditData, true>, TContext>({
    mutationKey: Common.UseCompleteVideoManualEditKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      completeVideoManualEdit(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useEnsureProductionStudioWorkspace = <
  TData = Common.EnsureProductionStudioWorkspaceMutationResult,
  TError = EnsureProductionStudioWorkspaceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<EnsureProductionStudioWorkspaceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<EnsureProductionStudioWorkspaceData, true>, TContext>({
    mutationKey: Common.UseEnsureProductionStudioWorkspaceKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      ensureProductionStudioWorkspace(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportProductionStudioClientPack = <
  TData = Common.ImportProductionStudioClientPackMutationResult,
  TError = ImportProductionStudioClientPackError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportProductionStudioClientPackData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportProductionStudioClientPackData, true>, TContext>({
    mutationKey: Common.UseImportProductionStudioClientPackKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importProductionStudioClientPack(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateProductionStudioBatch = <
  TData = Common.CreateProductionStudioBatchMutationResult,
  TError = CreateProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseCreateProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCopyProductionStudioBatch = <
  TData = Common.CopyProductionStudioBatchMutationResult,
  TError = CopyProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CopyProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CopyProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseCopyProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      copyProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSaveProductionStudioScript = <
  TData = Common.SaveProductionStudioScriptMutationResult,
  TError = SaveProductionStudioScriptError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SaveProductionStudioScriptData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SaveProductionStudioScriptData, true>, TContext>({
    mutationKey: Common.UseSaveProductionStudioScriptKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      saveProductionStudioScript(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportProductionStudioScripts = <
  TData = Common.ImportProductionStudioScriptsMutationResult,
  TError = ImportProductionStudioScriptsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ImportProductionStudioScriptsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportProductionStudioScriptsData, true>, TContext>({
    mutationKey: Common.UseImportProductionStudioScriptsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importProductionStudioScripts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRegenerateProductionStudioScripts = <
  TData = Common.RegenerateProductionStudioScriptsMutationResult,
  TError = RegenerateProductionStudioScriptsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<RegenerateProductionStudioScriptsData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RegenerateProductionStudioScriptsData, true>, TContext>({
    mutationKey: Common.UseRegenerateProductionStudioScriptsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      regenerateProductionStudioScripts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useConfirmProductionStudioScript = <
  TData = Common.ConfirmProductionStudioScriptMutationResult,
  TError = ConfirmProductionStudioScriptError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ConfirmProductionStudioScriptData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ConfirmProductionStudioScriptData, true>, TContext>({
    mutationKey: Common.UseConfirmProductionStudioScriptKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      confirmProductionStudioScript(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useConfirmAllProductionStudioScripts = <
  TData = Common.ConfirmAllProductionStudioScriptsMutationResult,
  TError = ConfirmAllProductionStudioScriptsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ConfirmAllProductionStudioScriptsData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ConfirmAllProductionStudioScriptsData, true>, TContext>({
    mutationKey: Common.UseConfirmAllProductionStudioScriptsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      confirmAllProductionStudioScripts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStartProductionStudioBatch = <
  TData = Common.StartProductionStudioBatchMutationResult,
  TError = StartProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StartProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StartProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseStartProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      startProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePauseProductionStudioBatch = <
  TData = Common.PauseProductionStudioBatchMutationResult,
  TError = PauseProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<PauseProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<PauseProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UsePauseProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      pauseProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelProductionStudioBatch = <
  TData = Common.CancelProductionStudioBatchMutationResult,
  TError = CancelProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CancelProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CancelProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseCancelProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useReviewProductionStudioOutput = <
  TData = Common.ReviewProductionStudioOutputMutationResult,
  TError = ReviewProductionStudioOutputError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ReviewProductionStudioOutputData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ReviewProductionStudioOutputData, true>, TContext>({
    mutationKey: Common.UseReviewProductionStudioOutputKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      reviewProductionStudioOutput(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSocialBrowserSession = <
  TData = Common.CreateSocialBrowserSessionMutationResult,
  TError = CreateSocialBrowserSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSocialBrowserSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSocialBrowserSessionData, true>, TContext>({
    mutationKey: Common.UseCreateSocialBrowserSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createSocialBrowserSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useIssueSocialBrowserViewerTicket = <
  TData = Common.IssueSocialBrowserViewerTicketMutationResult,
  TError = IssueSocialBrowserViewerTicketError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<IssueSocialBrowserViewerTicketData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<IssueSocialBrowserViewerTicketData, true>, TContext>({
    mutationKey: Common.UseIssueSocialBrowserViewerTicketKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      issueSocialBrowserViewerTicket(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useOpenSocialBrowserViewerConnection = <
  TData = Common.OpenSocialBrowserViewerConnectionMutationResult,
  TError = OpenSocialBrowserViewerConnectionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<OpenSocialBrowserViewerConnectionData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<OpenSocialBrowserViewerConnectionData, true>, TContext>({
    mutationKey: Common.UseOpenSocialBrowserViewerConnectionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      openSocialBrowserViewerConnection(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSetSocialBrowserSessionAutomation = <
  TData = Common.SetSocialBrowserSessionAutomationMutationResult,
  TError = SetSocialBrowserSessionAutomationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<SetSocialBrowserSessionAutomationData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SetSocialBrowserSessionAutomationData, true>, TContext>({
    mutationKey: Common.UseSetSocialBrowserSessionAutomationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      setSocialBrowserSessionAutomation(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCompleteSocialBrowserSession = <
  TData = Common.CompleteSocialBrowserSessionMutationResult,
  TError = CompleteSocialBrowserSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CompleteSocialBrowserSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CompleteSocialBrowserSessionData, true>, TContext>({
    mutationKey: Common.UseCompleteSocialBrowserSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      completeSocialBrowserSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelSocialBrowserSession = <
  TData = Common.CancelSocialBrowserSessionMutationResult,
  TError = CancelSocialBrowserSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CancelSocialBrowserSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CancelSocialBrowserSessionData, true>, TContext>({
    mutationKey: Common.UseCancelSocialBrowserSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelSocialBrowserSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExtendSocialBrowserSession = <
  TData = Common.ExtendSocialBrowserSessionMutationResult,
  TError = ExtendSocialBrowserSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ExtendSocialBrowserSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ExtendSocialBrowserSessionData, true>, TContext>({
    mutationKey: Common.UseExtendSocialBrowserSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      extendSocialBrowserSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSocialBrowserSessionBatch = <
  TData = Common.CreateSocialBrowserSessionBatchMutationResult,
  TError = CreateSocialBrowserSessionBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSocialBrowserSessionBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSocialBrowserSessionBatchData, true>, TContext>({
    mutationKey: Common.UseCreateSocialBrowserSessionBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createSocialBrowserSessionBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelSocialBrowserSessionBatch = <
  TData = Common.CancelSocialBrowserSessionBatchMutationResult,
  TError = CancelSocialBrowserSessionBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CancelSocialBrowserSessionBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CancelSocialBrowserSessionBatchData, true>, TContext>({
    mutationKey: Common.UseCancelSocialBrowserSessionBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelSocialBrowserSessionBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelSocialBrowserSessionBatchItem = <
  TData = Common.CancelSocialBrowserSessionBatchItemMutationResult,
  TError = CancelSocialBrowserSessionBatchItemError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CancelSocialBrowserSessionBatchItemData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CancelSocialBrowserSessionBatchItemData, true>, TContext>({
    mutationKey: Common.UseCancelSocialBrowserSessionBatchItemKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelSocialBrowserSessionBatchItem(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateMediaLibraryEntry = <
  TData = Common.CreateMediaLibraryEntryMutationResult,
  TError = CreateMediaLibraryEntryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateMediaLibraryEntryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateMediaLibraryEntryData, true>, TContext>({
    mutationKey: Common.UseCreateMediaLibraryEntryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createMediaLibraryEntry(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchDeleteMediaLibraryEntries = <
  TData = Common.BatchDeleteMediaLibraryEntriesMutationResult,
  TError = BatchDeleteMediaLibraryEntriesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchDeleteMediaLibraryEntriesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchDeleteMediaLibraryEntriesData, true>, TContext>({
    mutationKey: Common.UseBatchDeleteMediaLibraryEntriesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchDeleteMediaLibraryEntries(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useInitializeMediaLibraryUpload = <
  TData = Common.InitializeMediaLibraryUploadMutationResult,
  TError = InitializeMediaLibraryUploadError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<InitializeMediaLibraryUploadData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<InitializeMediaLibraryUploadData, true>, TContext>({
    mutationKey: Common.UseInitializeMediaLibraryUploadKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      initializeMediaLibraryUpload(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSignMediaLibraryUploadParts = <
  TData = Common.SignMediaLibraryUploadPartsMutationResult,
  TError = SignMediaLibraryUploadPartsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SignMediaLibraryUploadPartsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SignMediaLibraryUploadPartsData, true>, TContext>({
    mutationKey: Common.UseSignMediaLibraryUploadPartsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      signMediaLibraryUploadParts(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCompleteMediaLibraryUpload = <
  TData = Common.CompleteMediaLibraryUploadMutationResult,
  TError = CompleteMediaLibraryUploadError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CompleteMediaLibraryUploadData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CompleteMediaLibraryUploadData, true>, TContext>({
    mutationKey: Common.UseCompleteMediaLibraryUploadKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      completeMediaLibraryUpload(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAbortMediaLibraryUpload = <
  TData = Common.AbortMediaLibraryUploadMutationResult,
  TError = AbortMediaLibraryUploadError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AbortMediaLibraryUploadData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AbortMediaLibraryUploadData, true>, TContext>({
    mutationKey: Common.UseAbortMediaLibraryUploadKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      abortMediaLibraryUpload(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateMediaLibraryDownloadTask = <
  TData = Common.CreateMediaLibraryDownloadTaskMutationResult,
  TError = CreateMediaLibraryDownloadTaskError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateMediaLibraryDownloadTaskData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateMediaLibraryDownloadTaskData, true>, TContext>({
    mutationKey: Common.UseCreateMediaLibraryDownloadTaskKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createMediaLibraryDownloadTask(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportCanvasMaterialsToLibrary = <
  TData = Common.ImportCanvasMaterialsToLibraryMutationResult,
  TError = ImportCanvasMaterialsToLibraryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ImportCanvasMaterialsToLibraryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportCanvasMaterialsToLibraryData, true>, TContext>({
    mutationKey: Common.UseImportCanvasMaterialsToLibraryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importCanvasMaterialsToLibrary(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportCanvasMaterialsFromLibrary = <
  TData = Common.ImportCanvasMaterialsFromLibraryMutationResult,
  TError = ImportCanvasMaterialsFromLibraryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportCanvasMaterialsFromLibraryData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportCanvasMaterialsFromLibraryData, true>, TContext>({
    mutationKey: Common.UseImportCanvasMaterialsFromLibraryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importCanvasMaterialsFromLibrary(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCanvasMaterialDownloadTask = <
  TData = Common.CreateCanvasMaterialDownloadTaskMutationResult,
  TError = CreateCanvasMaterialDownloadTaskError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateCanvasMaterialDownloadTaskData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCanvasMaterialDownloadTaskData, true>, TContext>({
    mutationKey: Common.UseCreateCanvasMaterialDownloadTaskKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createCanvasMaterialDownloadTask(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExtractVariables = <
  TData = Common.ExtractVariablesMutationResult,
  TError = ExtractVariablesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ExtractVariablesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ExtractVariablesData, true>, TContext>({
    mutationKey: Common.UseExtractVariablesKeyFn(mutationKey),
    mutationFn: (clientOptions) => extractVariables(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGenerateAppTemplate = <
  TData = Common.GenerateAppTemplateMutationResult,
  TError = GenerateAppTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GenerateAppTemplateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GenerateAppTemplateData, true>, TContext>({
    mutationKey: Common.UseGenerateAppTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) => generateAppTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateMcpServer = <
  TData = Common.CreateMcpServerMutationResult,
  TError = CreateMcpServerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateMcpServerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateMcpServerData, true>, TContext>({
    mutationKey: Common.UseCreateMcpServerKeyFn(mutationKey),
    mutationFn: (clientOptions) => createMcpServer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateMcpServer = <
  TData = Common.UpdateMcpServerMutationResult,
  TError = UpdateMcpServerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateMcpServerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateMcpServerData, true>, TContext>({
    mutationKey: Common.UseUpdateMcpServerKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateMcpServer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteMcpServer = <
  TData = Common.DeleteMcpServerMutationResult,
  TError = DeleteMcpServerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteMcpServerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteMcpServerData, true>, TContext>({
    mutationKey: Common.UseDeleteMcpServerKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteMcpServer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useValidateMcpServer = <
  TData = Common.ValidateMcpServerMutationResult,
  TError = ValidateMcpServerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ValidateMcpServerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ValidateMcpServerData, true>, TContext>({
    mutationKey: Common.UseValidateMcpServerKeyFn(mutationKey),
    mutationFn: (clientOptions) => validateMcpServer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSharePage = <
  TData = Common.SharePageMutationResult,
  TError = SharePageError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SharePageData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SharePageData, true>, TContext>({
    mutationKey: Common.UseSharePageKeyFn(mutationKey),
    mutationFn: (clientOptions) => sharePage(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAddNodesToCanvasPage = <
  TData = Common.AddNodesToCanvasPageMutationResult,
  TError = AddNodesToCanvasPageError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AddNodesToCanvasPageData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AddNodesToCanvasPageData, true>, TContext>({
    mutationKey: Common.UseAddNodesToCanvasPageKeyFn(mutationKey),
    mutationFn: (clientOptions) => addNodesToCanvasPage(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRefreshToken = <
  TData = Common.RefreshTokenMutationResult,
  TError = RefreshTokenError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<unknown, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<unknown, true>, TContext>({
    mutationKey: Common.UseRefreshTokenKeyFn(mutationKey),
    mutationFn: (clientOptions) => refreshToken(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useEmailSignup = <
  TData = Common.EmailSignupMutationResult,
  TError = EmailSignupError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<EmailSignupData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<EmailSignupData, true>, TContext>({
    mutationKey: Common.UseEmailSignupKeyFn(mutationKey),
    mutationFn: (clientOptions) => emailSignup(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useEmailLogin = <
  TData = Common.EmailLoginMutationResult,
  TError = EmailLoginError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<EmailLoginData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<EmailLoginData, true>, TContext>({
    mutationKey: Common.UseEmailLoginKeyFn(mutationKey),
    mutationFn: (clientOptions) => emailLogin(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateVerification = <
  TData = Common.CreateVerificationMutationResult,
  TError = CreateVerificationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateVerificationData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateVerificationData, true>, TContext>({
    mutationKey: Common.UseCreateVerificationKeyFn(mutationKey),
    mutationFn: (clientOptions) => createVerification(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useResendVerification = <
  TData = Common.ResendVerificationMutationResult,
  TError = ResendVerificationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ResendVerificationData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ResendVerificationData, true>, TContext>({
    mutationKey: Common.UseResendVerificationKeyFn(mutationKey),
    mutationFn: (clientOptions) => resendVerification(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCheckVerification = <
  TData = Common.CheckVerificationMutationResult,
  TError = CheckVerificationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CheckVerificationData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CheckVerificationData, true>, TContext>({
    mutationKey: Common.UseCheckVerificationKeyFn(mutationKey),
    mutationFn: (clientOptions) => checkVerification(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useLogout = <
  TData = Common.LogoutMutationResult,
  TError = LogoutError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<unknown, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<unknown, true>, TContext>({
    mutationKey: Common.UseLogoutKeyFn(mutationKey),
    mutationFn: (clientOptions) => logout(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportCanvas = <
  TData = Common.ImportCanvasMutationResult,
  TError = ImportCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ImportCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ImportCanvasData, true>, TContext>({
    mutationKey: Common.UseImportCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => importCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCanvas = <
  TData = Common.CreateCanvasMutationResult,
  TError = CreateCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCanvasData, true>, TContext>({
    mutationKey: Common.UseCreateCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => createCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDuplicateCanvas = <
  TData = Common.DuplicateCanvasMutationResult,
  TError = DuplicateCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DuplicateCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DuplicateCanvasData, true>, TContext>({
    mutationKey: Common.UseDuplicateCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => duplicateCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCanvas = <
  TData = Common.UpdateCanvasMutationResult,
  TError = UpdateCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateCanvasData, true>, TContext>({
    mutationKey: Common.UseUpdateCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteCanvas = <
  TData = Common.DeleteCanvasMutationResult,
  TError = DeleteCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteCanvasData, true>, TContext>({
    mutationKey: Common.UseDeleteCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAutoNameCanvas = <
  TData = Common.AutoNameCanvasMutationResult,
  TError = AutoNameCanvasError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AutoNameCanvasData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AutoNameCanvasData, true>, TContext>({
    mutationKey: Common.UseAutoNameCanvasKeyFn(mutationKey),
    mutationFn: (clientOptions) => autoNameCanvas(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSetCanvasState = <
  TData = Common.SetCanvasStateMutationResult,
  TError = SetCanvasStateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SetCanvasStateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SetCanvasStateData, true>, TContext>({
    mutationKey: Common.UseSetCanvasStateKeyFn(mutationKey),
    mutationFn: (clientOptions) => setCanvasState(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSyncCanvasState = <
  TData = Common.SyncCanvasStateMutationResult,
  TError = SyncCanvasStateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SyncCanvasStateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SyncCanvasStateData, true>, TContext>({
    mutationKey: Common.UseSyncCanvasStateKeyFn(mutationKey),
    mutationFn: (clientOptions) => syncCanvasState(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCanvasVersion = <
  TData = Common.CreateCanvasVersionMutationResult,
  TError = CreateCanvasVersionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCanvasVersionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCanvasVersionData, true>, TContext>({
    mutationKey: Common.UseCreateCanvasVersionKeyFn(mutationKey),
    mutationFn: (clientOptions) => createCanvasVersion(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateWorkflowVariables = <
  TData = Common.UpdateWorkflowVariablesMutationResult,
  TError = UpdateWorkflowVariablesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateWorkflowVariablesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateWorkflowVariablesData, true>, TContext>({
    mutationKey: Common.UseUpdateWorkflowVariablesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateWorkflowVariables(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateDriveFile = <
  TData = Common.CreateDriveFileMutationResult,
  TError = CreateDriveFileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateDriveFileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateDriveFileData, true>, TContext>({
    mutationKey: Common.UseCreateDriveFileKeyFn(mutationKey),
    mutationFn: (clientOptions) => createDriveFile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchCreateDriveFiles = <
  TData = Common.BatchCreateDriveFilesMutationResult,
  TError = BatchCreateDriveFilesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchCreateDriveFilesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchCreateDriveFilesData, true>, TContext>({
    mutationKey: Common.UseBatchCreateDriveFilesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchCreateDriveFiles(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateDriveFile = <
  TData = Common.UpdateDriveFileMutationResult,
  TError = UpdateDriveFileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateDriveFileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateDriveFileData, true>, TContext>({
    mutationKey: Common.UseUpdateDriveFileKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateDriveFile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteDriveFile = <
  TData = Common.DeleteDriveFileMutationResult,
  TError = DeleteDriveFileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteDriveFileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteDriveFileData, true>, TContext>({
    mutationKey: Common.UseDeleteDriveFileKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteDriveFile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCanvasTemplate = <
  TData = Common.CreateCanvasTemplateMutationResult,
  TError = CreateCanvasTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCanvasTemplateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCanvasTemplateData, true>, TContext>({
    mutationKey: Common.UseCreateCanvasTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) => createCanvasTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCanvasTemplate = <
  TData = Common.UpdateCanvasTemplateMutationResult,
  TError = UpdateCanvasTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateCanvasTemplateData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateCanvasTemplateData, true>, TContext>({
    mutationKey: Common.UseUpdateCanvasTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateCanvasTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateResource = <
  TData = Common.UpdateResourceMutationResult,
  TError = UpdateResourceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateResourceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateResourceData, true>, TContext>({
    mutationKey: Common.UseUpdateResourceKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateResource(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateResource = <
  TData = Common.CreateResourceMutationResult,
  TError = CreateResourceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateResourceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateResourceData, true>, TContext>({
    mutationKey: Common.UseCreateResourceKeyFn(mutationKey),
    mutationFn: (clientOptions) => createResource(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateResourceWithFile = <
  TData = Common.CreateResourceWithFileMutationResult,
  TError = CreateResourceWithFileError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateResourceWithFileData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateResourceWithFileData, true>, TContext>({
    mutationKey: Common.UseCreateResourceWithFileKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createResourceWithFile(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchCreateResource = <
  TData = Common.BatchCreateResourceMutationResult,
  TError = BatchCreateResourceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchCreateResourceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchCreateResourceData, true>, TContext>({
    mutationKey: Common.UseBatchCreateResourceKeyFn(mutationKey),
    mutationFn: (clientOptions) => batchCreateResource(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useReindexResource = <
  TData = Common.ReindexResourceMutationResult,
  TError = ReindexResourceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ReindexResourceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ReindexResourceData, true>, TContext>({
    mutationKey: Common.UseReindexResourceKeyFn(mutationKey),
    mutationFn: (clientOptions) => reindexResource(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteResource = <
  TData = Common.DeleteResourceMutationResult,
  TError = DeleteResourceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteResourceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteResourceData, true>, TContext>({
    mutationKey: Common.UseDeleteResourceKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteResource(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStartExportJob = <
  TData = Common.StartExportJobMutationResult,
  TError = StartExportJobError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StartExportJobData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StartExportJobData, true>, TContext>({
    mutationKey: Common.UseStartExportJobKeyFn(mutationKey),
    mutationFn: (clientOptions) => startExportJob(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateDocument = <
  TData = Common.UpdateDocumentMutationResult,
  TError = UpdateDocumentError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateDocumentData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateDocumentData, true>, TContext>({
    mutationKey: Common.UseUpdateDocumentKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateDocument(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateDocument = <
  TData = Common.CreateDocumentMutationResult,
  TError = CreateDocumentError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateDocumentData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateDocumentData, true>, TContext>({
    mutationKey: Common.UseCreateDocumentKeyFn(mutationKey),
    mutationFn: (clientOptions) => createDocument(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteDocument = <
  TData = Common.DeleteDocumentMutationResult,
  TError = DeleteDocumentError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteDocumentData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteDocumentData, true>, TContext>({
    mutationKey: Common.UseDeleteDocumentKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteDocument(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchUpdateDocument = <
  TData = Common.BatchUpdateDocumentMutationResult,
  TError = BatchUpdateDocumentError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchUpdateDocumentData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchUpdateDocumentData, true>, TContext>({
    mutationKey: Common.UseBatchUpdateDocumentKeyFn(mutationKey),
    mutationFn: (clientOptions) => batchUpdateDocument(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateProject = <
  TData = Common.CreateProjectMutationResult,
  TError = CreateProjectError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateProjectData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateProjectData, true>, TContext>({
    mutationKey: Common.UseCreateProjectKeyFn(mutationKey),
    mutationFn: (clientOptions) => createProject(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProject = <
  TData = Common.UpdateProjectMutationResult,
  TError = UpdateProjectError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateProjectData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProjectData, true>, TContext>({
    mutationKey: Common.UseUpdateProjectKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateProject(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProjectItems = <
  TData = Common.UpdateProjectItemsMutationResult,
  TError = UpdateProjectItemsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateProjectItemsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProjectItemsData, true>, TContext>({
    mutationKey: Common.UseUpdateProjectItemsKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateProjectItems(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProject = <
  TData = Common.DeleteProjectMutationResult,
  TError = DeleteProjectError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProjectData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProjectData, true>, TContext>({
    mutationKey: Common.UseDeleteProjectKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteProject(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProjectItems = <
  TData = Common.DeleteProjectItemsMutationResult,
  TError = DeleteProjectItemsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProjectItemsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProjectItemsData, true>, TContext>({
    mutationKey: Common.UseDeleteProjectItemsKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteProjectItems(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCodeArtifact = <
  TData = Common.CreateCodeArtifactMutationResult,
  TError = CreateCodeArtifactError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCodeArtifactData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCodeArtifactData, true>, TContext>({
    mutationKey: Common.UseCreateCodeArtifactKeyFn(mutationKey),
    mutationFn: (clientOptions) => createCodeArtifact(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCodeArtifact = <
  TData = Common.UpdateCodeArtifactMutationResult,
  TError = UpdateCodeArtifactError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateCodeArtifactData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateCodeArtifactData, true>, TContext>({
    mutationKey: Common.UseUpdateCodeArtifactKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateCodeArtifact(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateShare = <
  TData = Common.CreateShareMutationResult,
  TError = CreateShareError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateShareData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateShareData, true>, TContext>({
    mutationKey: Common.UseCreateShareKeyFn(mutationKey),
    mutationFn: (clientOptions) => createShare(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteShare = <
  TData = Common.DeleteShareMutationResult,
  TError = DeleteShareError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteShareData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteShareData, true>, TContext>({
    mutationKey: Common.UseDeleteShareKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteShare(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDuplicateShare = <
  TData = Common.DuplicateShareMutationResult,
  TError = DuplicateShareError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DuplicateShareData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DuplicateShareData, true>, TContext>({
    mutationKey: Common.UseDuplicateShareKeyFn(mutationKey),
    mutationFn: (clientOptions) => duplicateShare(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateLabelClass = <
  TData = Common.CreateLabelClassMutationResult,
  TError = CreateLabelClassError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateLabelClassData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateLabelClassData, true>, TContext>({
    mutationKey: Common.UseCreateLabelClassKeyFn(mutationKey),
    mutationFn: (clientOptions) => createLabelClass(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateLabelClass = <
  TData = Common.UpdateLabelClassMutationResult,
  TError = UpdateLabelClassError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateLabelClassData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateLabelClassData, true>, TContext>({
    mutationKey: Common.UseUpdateLabelClassKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateLabelClass(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteLabelClass = <
  TData = Common.DeleteLabelClassMutationResult,
  TError = DeleteLabelClassError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteLabelClassData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteLabelClassData, true>, TContext>({
    mutationKey: Common.UseDeleteLabelClassKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteLabelClass(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateLabelInstance = <
  TData = Common.CreateLabelInstanceMutationResult,
  TError = CreateLabelInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateLabelInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateLabelInstanceData, true>, TContext>({
    mutationKey: Common.UseCreateLabelInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => createLabelInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateLabelInstance = <
  TData = Common.UpdateLabelInstanceMutationResult,
  TError = UpdateLabelInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateLabelInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateLabelInstanceData, true>, TContext>({
    mutationKey: Common.UseUpdateLabelInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateLabelInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteLabelInstance = <
  TData = Common.DeleteLabelInstanceMutationResult,
  TError = DeleteLabelInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteLabelInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteLabelInstanceData, true>, TContext>({
    mutationKey: Common.UseDeleteLabelInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteLabelInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAbortAction = <
  TData = Common.AbortActionMutationResult,
  TError = AbortActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AbortActionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AbortActionData, true>, TContext>({
    mutationKey: Common.UseAbortActionKeyFn(mutationKey),
    mutationFn: (clientOptions) => abortAction(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useInvokeSkill = <
  TData = Common.InvokeSkillMutationResult,
  TError = InvokeSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<InvokeSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<InvokeSkillData, true>, TContext>({
    mutationKey: Common.UseInvokeSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => invokeSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStreamInvokeSkill = <
  TData = Common.StreamInvokeSkillMutationResult,
  TError = StreamInvokeSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StreamInvokeSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StreamInvokeSkillData, true>, TContext>({
    mutationKey: Common.UseStreamInvokeSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => streamInvokeSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSkillInstance = <
  TData = Common.CreateSkillInstanceMutationResult,
  TError = CreateSkillInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSkillInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSkillInstanceData, true>, TContext>({
    mutationKey: Common.UseCreateSkillInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => createSkillInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSkillInstance = <
  TData = Common.UpdateSkillInstanceMutationResult,
  TError = UpdateSkillInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSkillInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSkillInstanceData, true>, TContext>({
    mutationKey: Common.UseUpdateSkillInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateSkillInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePinSkillInstance = <
  TData = Common.PinSkillInstanceMutationResult,
  TError = PinSkillInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<PinSkillInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<PinSkillInstanceData, true>, TContext>({
    mutationKey: Common.UsePinSkillInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => pinSkillInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUnpinSkillInstance = <
  TData = Common.UnpinSkillInstanceMutationResult,
  TError = UnpinSkillInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UnpinSkillInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UnpinSkillInstanceData, true>, TContext>({
    mutationKey: Common.UseUnpinSkillInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => unpinSkillInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteSkillInstance = <
  TData = Common.DeleteSkillInstanceMutationResult,
  TError = DeleteSkillInstanceError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteSkillInstanceData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteSkillInstanceData, true>, TContext>({
    mutationKey: Common.UseDeleteSkillInstanceKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteSkillInstance(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSkillTrigger = <
  TData = Common.CreateSkillTriggerMutationResult,
  TError = CreateSkillTriggerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateSkillTriggerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateSkillTriggerData, true>, TContext>({
    mutationKey: Common.UseCreateSkillTriggerKeyFn(mutationKey),
    mutationFn: (clientOptions) => createSkillTrigger(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSkillTrigger = <
  TData = Common.UpdateSkillTriggerMutationResult,
  TError = UpdateSkillTriggerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSkillTriggerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSkillTriggerData, true>, TContext>({
    mutationKey: Common.UseUpdateSkillTriggerKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateSkillTrigger(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteSkillTrigger = <
  TData = Common.DeleteSkillTriggerMutationResult,
  TError = DeleteSkillTriggerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteSkillTriggerData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteSkillTriggerData, true>, TContext>({
    mutationKey: Common.UseDeleteSkillTriggerKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteSkillTrigger(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGenerateMedia = <
  TData = Common.GenerateMediaMutationResult,
  TError = GenerateMediaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GenerateMediaData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GenerateMediaData, true>, TContext>({
    mutationKey: Common.UseGenerateMediaKeyFn(mutationKey),
    mutationFn: (clientOptions) => generateMedia(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePilotSession = <
  TData = Common.CreatePilotSessionMutationResult,
  TError = CreatePilotSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreatePilotSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreatePilotSessionData, true>, TContext>({
    mutationKey: Common.UseCreatePilotSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) => createPilotSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdatePilotSession = <
  TData = Common.UpdatePilotSessionMutationResult,
  TError = UpdatePilotSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdatePilotSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdatePilotSessionData, true>, TContext>({
    mutationKey: Common.UseUpdatePilotSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) => updatePilotSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRecoverPilotSession = <
  TData = Common.RecoverPilotSessionMutationResult,
  TError = RecoverPilotSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RecoverPilotSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RecoverPilotSessionData, true>, TContext>({
    mutationKey: Common.UseRecoverPilotSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) => recoverPilotSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteCopilotSession = <
  TData = Common.DeleteCopilotSessionMutationResult,
  TError = DeleteCopilotSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteCopilotSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteCopilotSessionData, true>, TContext>({
    mutationKey: Common.UseDeleteCopilotSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteCopilotSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useMaterializeCopilotSession = <
  TData = Common.MaterializeCopilotSessionMutationResult,
  TError = MaterializeCopilotSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<MaterializeCopilotSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<MaterializeCopilotSessionData, true>, TContext>({
    mutationKey: Common.UseMaterializeCopilotSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      materializeCopilotSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRestartWorkflowNode = <
  TData = Common.RestartWorkflowNodeMutationResult,
  TError = RestartWorkflowNodeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RestartWorkflowNodeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RestartWorkflowNodeData, true>, TContext>({
    mutationKey: Common.UseRestartWorkflowNodeKeyFn(mutationKey),
    mutationFn: (clientOptions) => restartWorkflowNode(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useStopPublishTask = <
  TData = Common.StopPublishTaskMutationResult,
  TError = StopPublishTaskError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<StopPublishTaskData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<StopPublishTaskData, true>, TContext>({
    mutationKey: Common.UseStopPublishTaskKeyFn(mutationKey),
    mutationFn: (clientOptions) => stopPublishTask(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useInitializeWorkflow = <
  TData = Common.InitializeWorkflowMutationResult,
  TError = InitializeWorkflowError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<InitializeWorkflowData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<InitializeWorkflowData, true>, TContext>({
    mutationKey: Common.UseInitializeWorkflowKeyFn(mutationKey),
    mutationFn: (clientOptions) => initializeWorkflow(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAbortWorkflow = <
  TData = Common.AbortWorkflowMutationResult,
  TError = AbortWorkflowError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AbortWorkflowData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AbortWorkflowData, true>, TContext>({
    mutationKey: Common.UseAbortWorkflowKeyFn(mutationKey),
    mutationFn: (clientOptions) => abortWorkflow(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateWorkflowApp = <
  TData = Common.CreateWorkflowAppMutationResult,
  TError = CreateWorkflowAppError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateWorkflowAppData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateWorkflowAppData, true>, TContext>({
    mutationKey: Common.UseCreateWorkflowAppKeyFn(mutationKey),
    mutationFn: (clientOptions) => createWorkflowApp(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteWorkflowApp = <
  TData = Common.DeleteWorkflowAppMutationResult,
  TError = DeleteWorkflowAppError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteWorkflowAppData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteWorkflowAppData, true>, TContext>({
    mutationKey: Common.UseDeleteWorkflowAppKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteWorkflowApp(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExecuteWorkflowApp = <
  TData = Common.ExecuteWorkflowAppMutationResult,
  TError = ExecuteWorkflowAppError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ExecuteWorkflowAppData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ExecuteWorkflowAppData, true>, TContext>({
    mutationKey: Common.UseExecuteWorkflowAppKeyFn(mutationKey),
    mutationFn: (clientOptions) => executeWorkflowApp(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateSchedule = <
  TData = Common.CreateScheduleMutationResult,
  TError = CreateScheduleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateScheduleData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateScheduleData, true>, TContext>({
    mutationKey: Common.UseCreateScheduleKeyFn(mutationKey),
    mutationFn: (clientOptions) => createSchedule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSchedule = <
  TData = Common.UpdateScheduleMutationResult,
  TError = UpdateScheduleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateScheduleData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateScheduleData, true>, TContext>({
    mutationKey: Common.UseUpdateScheduleKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateSchedule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteSchedule = <
  TData = Common.DeleteScheduleMutationResult,
  TError = DeleteScheduleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteScheduleData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteScheduleData, true>, TContext>({
    mutationKey: Common.UseDeleteScheduleKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteSchedule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListSchedules = <
  TData = Common.ListSchedulesMutationResult,
  TError = ListSchedulesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ListSchedulesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ListSchedulesData, true>, TContext>({
    mutationKey: Common.UseListSchedulesKeyFn(mutationKey),
    mutationFn: (clientOptions) => listSchedules(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGetScheduleDetail = <
  TData = Common.GetScheduleDetailMutationResult,
  TError = GetScheduleDetailError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GetScheduleDetailData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GetScheduleDetailData, true>, TContext>({
    mutationKey: Common.UseGetScheduleDetailKeyFn(mutationKey),
    mutationFn: (clientOptions) => getScheduleDetail(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGetScheduleRecords = <
  TData = Common.GetScheduleRecordsMutationResult,
  TError = GetScheduleRecordsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GetScheduleRecordsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GetScheduleRecordsData, true>, TContext>({
    mutationKey: Common.UseGetScheduleRecordsKeyFn(mutationKey),
    mutationFn: (clientOptions) => getScheduleRecords(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListAllScheduleRecords = <
  TData = Common.ListAllScheduleRecordsMutationResult,
  TError = ListAllScheduleRecordsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ListAllScheduleRecordsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ListAllScheduleRecordsData, true>, TContext>({
    mutationKey: Common.UseListAllScheduleRecordsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listAllScheduleRecords(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGetAvailableTools = <
  TData = Common.GetAvailableToolsMutationResult,
  TError = GetAvailableToolsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<unknown, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<unknown, true>, TContext>({
    mutationKey: Common.UseGetAvailableToolsKeyFn(mutationKey),
    mutationFn: (clientOptions) => getAvailableTools(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGetScheduleRecordDetail = <
  TData = Common.GetScheduleRecordDetailMutationResult,
  TError = GetScheduleRecordDetailError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GetScheduleRecordDetailData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GetScheduleRecordDetailData, true>, TContext>({
    mutationKey: Common.UseGetScheduleRecordDetailKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      getScheduleRecordDetail(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGetRecordSnapshot = <
  TData = Common.GetRecordSnapshotMutationResult,
  TError = GetRecordSnapshotError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GetRecordSnapshotData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GetRecordSnapshotData, true>, TContext>({
    mutationKey: Common.UseGetRecordSnapshotKeyFn(mutationKey),
    mutationFn: (clientOptions) => getRecordSnapshot(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useTriggerScheduleManually = <
  TData = Common.TriggerScheduleManuallyMutationResult,
  TError = TriggerScheduleManuallyError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<TriggerScheduleManuallyData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<TriggerScheduleManuallyData, true>, TContext>({
    mutationKey: Common.UseTriggerScheduleManuallyKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      triggerScheduleManually(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRetryScheduleRecord = <
  TData = Common.RetryScheduleRecordMutationResult,
  TError = RetryScheduleRecordError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RetryScheduleRecordData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RetryScheduleRecordData, true>, TContext>({
    mutationKey: Common.UseRetryScheduleRecordKeyFn(mutationKey),
    mutationFn: (clientOptions) => retryScheduleRecord(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCliApiKey = <
  TData = Common.CreateCliApiKeyMutationResult,
  TError = CreateCliApiKeyError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCliApiKeyData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCliApiKeyData, true>, TContext>({
    mutationKey: Common.UseCreateCliApiKeyKeyFn(mutationKey),
    mutationFn: (clientOptions) => createCliApiKey(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateOpenapiConfig = <
  TData = Common.UpdateOpenapiConfigMutationResult,
  TError = UpdateOpenapiConfigError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateOpenapiConfigData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateOpenapiConfigData, true>, TContext>({
    mutationKey: Common.UseUpdateOpenapiConfigKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateOpenapiConfig(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUploadOpenapiFiles = <
  TData = Common.UploadOpenapiFilesMutationResult,
  TError = UploadOpenapiFilesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UploadOpenapiFilesData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UploadOpenapiFilesData, true>, TContext>({
    mutationKey: Common.UseUploadOpenapiFilesKeyFn(mutationKey),
    mutationFn: (clientOptions) => uploadOpenapiFiles(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRunWorkflowViaApi = <
  TData = Common.RunWorkflowViaApiMutationResult,
  TError = RunWorkflowViaApiError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RunWorkflowViaApiData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RunWorkflowViaApiData, true>, TContext>({
    mutationKey: Common.UseRunWorkflowViaApiKeyFn(mutationKey),
    mutationFn: (clientOptions) => runWorkflowViaApi(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGenerateWorkflowViaCopilot = <
  TData = Common.GenerateWorkflowViaCopilotMutationResult,
  TError = GenerateWorkflowViaCopilotError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GenerateWorkflowViaCopilotData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<GenerateWorkflowViaCopilotData, true>, TContext>({
    mutationKey: Common.UseGenerateWorkflowViaCopilotKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      generateWorkflowViaCopilot(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAbortWorkflowViaApi = <
  TData = Common.AbortWorkflowViaApiMutationResult,
  TError = AbortWorkflowViaApiError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AbortWorkflowViaApiData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AbortWorkflowViaApiData, true>, TContext>({
    mutationKey: Common.UseAbortWorkflowViaApiKeyFn(mutationKey),
    mutationFn: (clientOptions) => abortWorkflowViaApi(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSubmitForm = <
  TData = Common.SubmitFormMutationResult,
  TError = SubmitFormError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SubmitFormData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SubmitFormData, true>, TContext>({
    mutationKey: Common.UseSubmitFormKeyFn(mutationKey),
    mutationFn: (clientOptions) => submitForm(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useActivateInvitationCode = <
  TData = Common.ActivateInvitationCodeMutationResult,
  TError = ActivateInvitationCodeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ActivateInvitationCodeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ActivateInvitationCodeData, true>, TContext>({
    mutationKey: Common.UseActivateInvitationCodeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      activateInvitationCode(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCheckoutSession = <
  TData = Common.CreateCheckoutSessionMutationResult,
  TError = CreateCheckoutSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCheckoutSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCheckoutSessionData, true>, TContext>({
    mutationKey: Common.UseCreateCheckoutSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createCheckoutSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateCreditPackCheckoutSession = <
  TData = Common.CreateCreditPackCheckoutSessionMutationResult,
  TError = CreateCreditPackCheckoutSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateCreditPackCheckoutSessionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateCreditPackCheckoutSessionData, true>, TContext>({
    mutationKey: Common.UseCreateCreditPackCheckoutSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createCreditPackCheckoutSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePortalSession = <
  TData = Common.CreatePortalSessionMutationResult,
  TError = CreatePortalSessionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<unknown, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<unknown, true>, TContext>({
    mutationKey: Common.UseCreatePortalSessionKeyFn(mutationKey),
    mutationFn: (clientOptions) => createPortalSession(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePayOrder = <
  TData = Common.CreatePayOrderMutationResult,
  TError = CreatePayOrderError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreatePayOrderData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreatePayOrderData, true>, TContext>({
    mutationKey: Common.UseCreatePayOrderKeyFn(mutationKey),
    mutationFn: (clientOptions) => createPayOrder(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSearch = <
  TData = Common.SearchMutationResult,
  TError = SearchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SearchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SearchData, true>, TContext>({
    mutationKey: Common.UseSearchKeyFn(mutationKey),
    mutationFn: (clientOptions) => search(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useMultiLingualWebSearch = <
  TData = Common.MultiLingualWebSearchMutationResult,
  TError = MultiLingualWebSearchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<MultiLingualWebSearchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<MultiLingualWebSearchData, true>, TContext>({
    mutationKey: Common.UseMultiLingualWebSearchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      multiLingualWebSearch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateManagedModel = <
  TData = Common.CreateManagedModelMutationResult,
  TError = CreateManagedModelError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateManagedModelData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateManagedModelData, true>, TContext>({
    mutationKey: Common.UseCreateManagedModelKeyFn(mutationKey),
    mutationFn: (clientOptions) => createManagedModel(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateManagedModel = <
  TData = Common.UpdateManagedModelMutationResult,
  TError = UpdateManagedModelError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateManagedModelData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateManagedModelData, true>, TContext>({
    mutationKey: Common.UseUpdateManagedModelKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateManagedModel(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateManagedModelStatus = <
  TData = Common.UpdateManagedModelStatusMutationResult,
  TError = UpdateManagedModelStatusError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateManagedModelStatusData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateManagedModelStatusData, true>, TContext>({
    mutationKey: Common.UseUpdateManagedModelStatusKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateManagedModelStatus(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteManagedModel = <
  TData = Common.DeleteManagedModelMutationResult,
  TError = DeleteManagedModelError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteManagedModelData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteManagedModelData, true>, TContext>({
    mutationKey: Common.UseDeleteManagedModelKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteManagedModel(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateProvider = <
  TData = Common.CreateProviderMutationResult,
  TError = CreateProviderError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateProviderData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateProviderData, true>, TContext>({
    mutationKey: Common.UseCreateProviderKeyFn(mutationKey),
    mutationFn: (clientOptions) => createProvider(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProvider = <
  TData = Common.UpdateProviderMutationResult,
  TError = UpdateProviderError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateProviderData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProviderData, true>, TContext>({
    mutationKey: Common.UseUpdateProviderKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateProvider(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProvider = <
  TData = Common.DeleteProviderMutationResult,
  TError = DeleteProviderError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProviderData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProviderData, true>, TContext>({
    mutationKey: Common.UseDeleteProviderKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteProvider(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useTestProviderConnection = <
  TData = Common.TestProviderConnectionMutationResult,
  TError = TestProviderConnectionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<TestProviderConnectionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<TestProviderConnectionData, true>, TContext>({
    mutationKey: Common.UseTestProviderConnectionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      testProviderConnection(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateProviderItem = <
  TData = Common.CreateProviderItemMutationResult,
  TError = CreateProviderItemError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateProviderItemData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateProviderItemData, true>, TContext>({
    mutationKey: Common.UseCreateProviderItemKeyFn(mutationKey),
    mutationFn: (clientOptions) => createProviderItem(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchCreateProviderItems = <
  TData = Common.BatchCreateProviderItemsMutationResult,
  TError = BatchCreateProviderItemsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchCreateProviderItemsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchCreateProviderItemsData, true>, TContext>({
    mutationKey: Common.UseBatchCreateProviderItemsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchCreateProviderItems(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProviderItem = <
  TData = Common.UpdateProviderItemMutationResult,
  TError = UpdateProviderItemError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateProviderItemData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProviderItemData, true>, TContext>({
    mutationKey: Common.UseUpdateProviderItemKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateProviderItem(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBatchUpdateProviderItems = <
  TData = Common.BatchUpdateProviderItemsMutationResult,
  TError = BatchUpdateProviderItemsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<BatchUpdateProviderItemsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<BatchUpdateProviderItemsData, true>, TContext>({
    mutationKey: Common.UseBatchUpdateProviderItemsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      batchUpdateProviderItems(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProviderItem = <
  TData = Common.DeleteProviderItemMutationResult,
  TError = DeleteProviderItemError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProviderItemData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProviderItemData, true>, TContext>({
    mutationKey: Common.UseDeleteProviderItemKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteProviderItem(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateToolset = <
  TData = Common.CreateToolsetMutationResult,
  TError = CreateToolsetError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateToolsetData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateToolsetData, true>, TContext>({
    mutationKey: Common.UseCreateToolsetKeyFn(mutationKey),
    mutationFn: (clientOptions) => createToolset(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateToolset = <
  TData = Common.UpdateToolsetMutationResult,
  TError = UpdateToolsetError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateToolsetData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateToolsetData, true>, TContext>({
    mutationKey: Common.UseUpdateToolsetKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateToolset(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteToolset = <
  TData = Common.DeleteToolsetMutationResult,
  TError = DeleteToolsetError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteToolsetData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteToolsetData, true>, TContext>({
    mutationKey: Common.UseDeleteToolsetKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteToolset(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExecuteTool = <
  TData = Common.ExecuteToolMutationResult,
  TError = ExecuteToolError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ExecuteToolData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ExecuteToolData, true>, TContext>({
    mutationKey: Common.UseExecuteToolKeyFn(mutationKey),
    mutationFn: (clientOptions) => executeTool(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAuthorizeComposioConnection = <
  TData = Common.AuthorizeComposioConnectionMutationResult,
  TError = AuthorizeComposioConnectionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AuthorizeComposioConnectionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<AuthorizeComposioConnectionData, true>, TContext>({
    mutationKey: Common.UseAuthorizeComposioConnectionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      authorizeComposioConnection(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRevokeComposioConnection = <
  TData = Common.RevokeComposioConnectionMutationResult,
  TError = RevokeComposioConnectionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RevokeComposioConnectionData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RevokeComposioConnectionData, true>, TContext>({
    mutationKey: Common.UseRevokeComposioConnectionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      revokeComposioConnection(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useScrape = <
  TData = Common.ScrapeMutationResult,
  TError = ScrapeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ScrapeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ScrapeData, true>, TContext>({
    mutationKey: Common.UseScrapeKeyFn(mutationKey),
    mutationFn: (clientOptions) => scrape(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpload = <
  TData = Common.UploadMutationResult,
  TError = UploadError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UploadData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UploadData, true>, TContext>({
    mutationKey: Common.UseUploadKeyFn(mutationKey),
    mutationFn: (clientOptions) => upload(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useConvert = <
  TData = Common.ConvertMutationResult,
  TError = ConvertError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ConvertData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ConvertData, true>, TContext>({
    mutationKey: Common.UseConvertKeyFn(mutationKey),
    mutationFn: (clientOptions) => convert(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useValidateVoucher = <
  TData = Common.ValidateVoucherMutationResult,
  TError = ValidateVoucherError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ValidateVoucherData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ValidateVoucherData, true>, TContext>({
    mutationKey: Common.UseValidateVoucherKeyFn(mutationKey),
    mutationFn: (clientOptions) => validateVoucher(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateVoucherInvitation = <
  TData = Common.CreateVoucherInvitationMutationResult,
  TError = CreateVoucherInvitationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateVoucherInvitationData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreateVoucherInvitationData, true>, TContext>({
    mutationKey: Common.UseCreateVoucherInvitationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createVoucherInvitation(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useClaimVoucherInvitation = <
  TData = Common.ClaimVoucherInvitationMutationResult,
  TError = ClaimVoucherInvitationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ClaimVoucherInvitationData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<ClaimVoucherInvitationData, true>, TContext>({
    mutationKey: Common.UseClaimVoucherInvitationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      claimVoucherInvitation(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePromptSkill = <
  TData = Common.CreatePromptSkillMutationResult,
  TError = CreatePromptSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreatePromptSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<CreatePromptSkillData, true>, TContext>({
    mutationKey: Common.UseCreatePromptSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => createPromptSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdatePromptSkill = <
  TData = Common.UpdatePromptSkillMutationResult,
  TError = UpdatePromptSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdatePromptSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdatePromptSkillData, true>, TContext>({
    mutationKey: Common.UseUpdatePromptSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => updatePromptSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useTogglePromptSkill = <
  TData = Common.TogglePromptSkillMutationResult,
  TError = TogglePromptSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<TogglePromptSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<TogglePromptSkillData, true>, TContext>({
    mutationKey: Common.UseTogglePromptSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => togglePromptSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeletePromptSkill = <
  TData = Common.DeletePromptSkillMutationResult,
  TError = DeletePromptSkillError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeletePromptSkillData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeletePromptSkillData, true>, TContext>({
    mutationKey: Common.UseDeletePromptSkillKeyFn(mutationKey),
    mutationFn: (clientOptions) => deletePromptSkill(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSaveVideoEditProjectSnapshot = <
  TData = Common.SaveVideoEditProjectSnapshotMutationResult,
  TError = SaveVideoEditProjectSnapshotError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<SaveVideoEditProjectSnapshotData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<SaveVideoEditProjectSnapshotData, true>, TContext>({
    mutationKey: Common.UseSaveVideoEditProjectSnapshotKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      saveVideoEditProjectSnapshot(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdatePage = <
  TData = Common.UpdatePageMutationResult,
  TError = UpdatePageError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdatePageData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdatePageData, true>, TContext>({
    mutationKey: Common.UseUpdatePageKeyFn(mutationKey),
    mutationFn: (clientOptions) => updatePage(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateSettings = <
  TData = Common.UpdateSettingsMutationResult,
  TError = UpdateSettingsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateSettingsData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateSettingsData, true>, TContext>({
    mutationKey: Common.UseUpdateSettingsKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateSettings(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProductionStudioClientPackStatus = <
  TData = Common.UpdateProductionStudioClientPackStatusMutationResult,
  TError = UpdateProductionStudioClientPackStatusError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateProductionStudioClientPackStatusData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProductionStudioClientPackStatusData, true>, TContext>({
    mutationKey: Common.UseUpdateProductionStudioClientPackStatusKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateProductionStudioClientPackStatus(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProductionStudioClientPackAsset = <
  TData = Common.UpdateProductionStudioClientPackAssetMutationResult,
  TError = UpdateProductionStudioClientPackAssetError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateProductionStudioClientPackAssetData, true>,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProductionStudioClientPackAssetData, true>, TContext>({
    mutationKey: Common.UseUpdateProductionStudioClientPackAssetKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateProductionStudioClientPackAsset(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateProductionStudioBatch = <
  TData = Common.UpdateProductionStudioBatchMutationResult,
  TError = UpdateProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseUpdateProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateMediaLibraryEntry = <
  TData = Common.UpdateMediaLibraryEntryMutationResult,
  TError = UpdateMediaLibraryEntryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateMediaLibraryEntryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateMediaLibraryEntryData, true>, TContext>({
    mutationKey: Common.UseUpdateMediaLibraryEntryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateMediaLibraryEntry(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCliApiKey = <
  TData = Common.UpdateCliApiKeyMutationResult,
  TError = UpdateCliApiKeyError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateCliApiKeyData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UpdateCliApiKeyData, true>, TContext>({
    mutationKey: Common.UseUpdateCliApiKeyKeyFn(mutationKey),
    mutationFn: (clientOptions) => updateCliApiKey(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteSocialAccount = <
  TData = Common.DeleteSocialAccountMutationResult,
  TError = DeleteSocialAccountError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteSocialAccountData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteSocialAccountData, true>, TContext>({
    mutationKey: Common.UseDeleteSocialAccountKeyFn(mutationKey),
    mutationFn: (clientOptions) => deleteSocialAccount(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteSocialAccountCategory = <
  TData = Common.DeleteSocialAccountCategoryMutationResult,
  TError = DeleteSocialAccountCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteSocialAccountCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteSocialAccountCategoryData, true>, TContext>({
    mutationKey: Common.UseDeleteSocialAccountCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteSocialAccountCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUnbindSocialAccountFromCategory = <
  TData = Common.UnbindSocialAccountFromCategoryMutationResult,
  TError = UnbindSocialAccountFromCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UnbindSocialAccountFromCategoryData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<UnbindSocialAccountFromCategoryData, true>, TContext>({
    mutationKey: Common.UseUnbindSocialAccountFromCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      unbindSocialAccountFromCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProductionStudioBatch = <
  TData = Common.DeleteProductionStudioBatchMutationResult,
  TError = DeleteProductionStudioBatchError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProductionStudioBatchData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProductionStudioBatchData, true>, TContext>({
    mutationKey: Common.UseDeleteProductionStudioBatchKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteProductionStudioBatch(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteProductionStudioScript = <
  TData = Common.DeleteProductionStudioScriptMutationResult,
  TError = DeleteProductionStudioScriptError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteProductionStudioScriptData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeleteProductionStudioScriptData, true>, TContext>({
    mutationKey: Common.UseDeleteProductionStudioScriptKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteProductionStudioScript(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeletePageNode = <
  TData = Common.DeletePageNodeMutationResult,
  TError = DeletePageNodeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeletePageNodeData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<DeletePageNodeData, true>, TContext>({
    mutationKey: Common.UseDeletePageNodeKeyFn(mutationKey),
    mutationFn: (clientOptions) => deletePageNode(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRevokeCliApiKey = <
  TData = Common.RevokeCliApiKeyMutationResult,
  TError = RevokeCliApiKeyError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown,
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<RevokeCliApiKeyData, true>, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation<TData, TError, Options<RevokeCliApiKeyData, true>, TContext>({
    mutationKey: Common.UseRevokeCliApiKeyKeyFn(mutationKey),
    mutationFn: (clientOptions) => revokeCliApiKey(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
